import { Component, ViewEncapsulation, Input, EventEmitter, Directive, ElementRef, Output, Injectable, Pipe, Optional, SkipSelf, ComponentFactoryResolver, ApplicationRef, Injector, NgModule, TemplateRef, ViewChild, ViewContainerRef, HostListener, Renderer2, ContentChildren, ChangeDetectionStrategy, ChangeDetectorRef, isDevMode, ɵɵdefineInjectable, InjectionToken, inject, LOCALE_ID, ɵɵinject, Inject, NgZone } from '@angular/core';
import { NG_VALUE_ACCESSOR, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { fromEvent, Subject, Observable, merge, Subscription } from 'rxjs';
import { map, finalize, takeUntil } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { trigger, transition, animate, keyframes, style, state } from '@angular/animations';
import { CdkColumnDef, CdkTableModule } from '@angular/cdk/table';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/router';
import * as ɵngcc2 from '@angular/platform-browser';
import * as ɵngcc3 from '@angular/common';
import * as ɵngcc4 from '@angular/forms';
import * as ɵngcc5 from '@angular/cdk/table';

function NwbAlertComponent_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 4);
    ɵngcc0.ɵɵelement(1, "i");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMap(ctx_r0.config.icon);
} }
const _c0 = function (a0) { return { "is-active": a0 }; };
const _c1 = ["nwbAnimatedCardClosed", ""];
const _c2 = ["*"];
const _c3 = ["componentSection"];
const _c4 = ["okButton"];
const _c5 = ["cancelButton"];
const _c6 = ["backdropButton"];
const _c7 = ["header"];
const _c8 = ["footer"];
function NwbDialogComponent_header_3_button_4_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 13, 14);
    ɵngcc0.ɵɵlistener("click", function NwbDialogComponent_header_3_button_4_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r8 = ɵngcc0.ɵɵnextContext(2); return ctx_r8.backdropHandler(); });
    ɵngcc0.ɵɵelementEnd();
} }
function NwbDialogComponent_header_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "header", 9, 10);
    ɵngcc0.ɵɵelementStart(2, "p", 11);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, NwbDialogComponent_header_3_button_4_Template, 2, 0, "button", 12);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.config.title);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.config.hasBackdrop);
} }
function NwbDialogComponent_section_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "section", 15);
    ɵngcc0.ɵɵelement(1, "nwb-spinner");
    ɵngcc0.ɵɵelementEnd();
} }
function NwbDialogComponent_section_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "section", 16);
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("innerHTML", ctx_r2.config.message, ɵngcc0.ɵɵsanitizeHtml);
} }
function NwbDialogComponent_footer_9_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r15 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 21, 22);
    ɵngcc0.ɵɵlistener("click", function NwbDialogComponent_footer_9_button_2_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r15); const ctx_r14 = ɵngcc0.ɵɵnextContext(2); return ctx_r14.cancelHandler(); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1("", ctx_r11.config.cancelButtonText, " ");
} }
function NwbDialogComponent_footer_9_button_3_Template(rf, ctx) { if (rf & 1) {
    const _r18 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 23, 24);
    ɵngcc0.ɵɵlistener("click", function NwbDialogComponent_footer_9_button_3_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r18); const ctx_r17 = ɵngcc0.ɵɵnextContext(2); return ctx_r17.okHandler(); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1("", ctx_r12.config.okButtonText, " ");
} }
function NwbDialogComponent_footer_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "footer", 17, 18);
    ɵngcc0.ɵɵtemplate(2, NwbDialogComponent_footer_9_button_2_Template, 3, 1, "button", 19);
    ɵngcc0.ɵɵtemplate(3, NwbDialogComponent_footer_9_button_3_Template, 3, 1, "button", 20);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.config.cancelButtonText);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.config.okButtonText);
} }
const _c9 = function (a0) { return { "width": a0 }; };
const _c10 = function (a0) { return { "is-hidden": a0 }; };
function NwbDropdownComponent_div_7_ng_container_2_hr_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "hr", 12);
} }
const _c11 = function (a0, a1) { return { "is-active": a0, "is-disabled": a1 }; };
function NwbDropdownComponent_div_7_ng_container_2_a_2_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 13);
    ɵngcc0.ɵɵlistener("click", function NwbDropdownComponent_div_7_ng_container_2_a_2_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); const option_r2 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r5 = ɵngcc0.ɵɵnextContext(2); return ctx_r5.selectOption(option_r2); });
    ɵngcc0.ɵɵpipe(1, "safeHtml");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(4, _c11, option_r2.selected, option_r2.disabled))("innerHTML", ɵngcc0.ɵɵpipeBind1(1, 2, option_r2.text), ɵngcc0.ɵɵsanitizeHtml);
} }
function NwbDropdownComponent_div_7_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, NwbDropdownComponent_div_7_ng_container_2_hr_1_Template, 1, 0, "hr", 10);
    ɵngcc0.ɵɵtemplate(2, NwbDropdownComponent_div_7_ng_container_2_a_2_Template, 2, 7, "a", 11);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const option_r2 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", option_r2.divider);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !option_r2.divider);
} }
function NwbDropdownComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵelementStart(1, "div", 8);
    ɵngcc0.ɵɵtemplate(2, NwbDropdownComponent_div_7_ng_container_2_Template, 3, 2, "ng-container", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0._options);
} }
const _c12 = function (a0, a1, a2) { return { "is-active": a0, "right-to-left": a1, "is-up": a2 }; };
const _c13 = function (a1, a2) { return ["button", a1, a2]; };
const _c14 = ["input"];
const _c15 = function (a0) { return { "width.px": a0 }; };
function NwbEditInPlaceComponent_input_3_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "input", 4, 5);
    ɵngcc0.ɵɵlistener("ngModelChange", function NwbEditInPlaceComponent_input_3_Template_input_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.value = $event; })("focus", function NwbEditInPlaceComponent_input_3_Template_input_focus_0_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.edit(); })("blur", function NwbEditInPlaceComponent_input_3_Template_input_blur_0_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.onSubmit(); })("keyup.enter", function NwbEditInPlaceComponent_input_3_Template_input_keyup_enter_0_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.onSubmit(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("nwb-editable", !ctx_r0.editing)("nwb-editing", ctx_r0.editing)("nwb-is-loading", ctx_r0.isLoading);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.value)("ngStyle", ɵngcc0.ɵɵpureFunction1(8, _c15, ctx_r0.inputWidth));
} }
const _c16 = ["inputSearch"];
function NwbModalSearchComponent_header_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "header", 14, 15);
} }
const _c17 = function (a0, a1, a2, a3) { return { "selected": a0, "not-selectable": a1, "is-child": a2, "is-parent": a3 }; };
function NwbModalSearchComponent_div_11_a_1_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 18);
    ɵngcc0.ɵɵlistener("mousemove", function NwbModalSearchComponent_div_11_a_1_Template_a_mousemove_0_listener() { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r9 = ɵngcc0.ɵɵnextContext(2); return ctx_r9.mouseMove(); })("mouseover", function NwbModalSearchComponent_div_11_a_1_Template_a_mouseover_0_listener() { ɵngcc0.ɵɵrestoreView(_r10); const i_r8 = ctx.index; const ctx_r11 = ɵngcc0.ɵɵnextContext(2); return ctx_r11.mouseOver(i_r8); })("click", function NwbModalSearchComponent_div_11_a_1_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r12 = ɵngcc0.ɵɵnextContext(2); return ctx_r12.selectValue(); });
    ɵngcc0.ɵɵelement(1, "div", 19);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const row_r7 = ctx.$implicit;
    const i_r8 = ctx.index;
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction4(3, _c17, row_r7.isSelectable && i_r8 === ctx_r6.selectedFoundRow, !row_r7.isSelectable, row_r7.isChild, row_r7.isParent))("tabindex", i_r8);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("innerHTML", row_r7.text, ɵngcc0.ɵɵsanitizeHtml);
} }
function NwbModalSearchComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 16);
    ɵngcc0.ɵɵtemplate(1, NwbModalSearchComponent_div_11_a_1_Template, 2, 8, "a", 17);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r2.foundRows);
} }
function NwbModalSearchComponent_nwb_spinner_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "nwb-spinner");
} }
function NwbModalSearchComponent_footer_13_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "footer", 20, 21);
} }
const _c18 = function (a0, a1) { return { "has-no-header": a0, "has-no-footer": a1 }; };
function NwbPaginatorComponent_strong_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "strong", 9);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.pageSize);
} }
function NwbPaginatorComponent_li_6_a_10_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 18);
    ɵngcc0.ɵɵlistener("click", function NwbPaginatorComponent_li_6_a_10_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r5); const pageSizeOption_r3 = ctx.$implicit; const ctx_r4 = ɵngcc0.ɵɵnextContext(2); return ctx_r4.changePageSize(pageSizeOption_r3); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const pageSizeOption_r3 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", pageSizeOption_r3, " ");
} }
function NwbPaginatorComponent_li_6_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li");
    ɵngcc0.ɵɵelementStart(1, "div", 10);
    ɵngcc0.ɵɵlistener("click", function NwbPaginatorComponent_li_6_Template_div_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.dropDownIsActive = !ctx_r6.dropDownIsActive; });
    ɵngcc0.ɵɵelementStart(2, "div", 11);
    ɵngcc0.ɵɵelementStart(3, "button", 12);
    ɵngcc0.ɵɵelementStart(4, "span");
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "span", 13);
    ɵngcc0.ɵɵelement(7, "i", 14);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "div", 15);
    ɵngcc0.ɵɵelementStart(9, "div", 16);
    ɵngcc0.ɵɵtemplate(10, NwbPaginatorComponent_li_6_a_10_Template, 2, 1, "a", 17);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(3, _c0, ctx_r1.dropDownIsActive));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.pageSize);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1._displayedPageSizeOptions);
} }
function NwbSnackbarComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵelementStart(1, "button", 4);
    ɵngcc0.ɵɵlistener("click", function NwbSnackbarComponent_div_3_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r1 = ɵngcc0.ɵɵnextContext(); return ctx_r1.dismiss(true); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMap("button " + (ctx_r0.config.buttonColor ? ctx_r0.config.buttonColor : "is-success"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("", ctx_r0.config.action, " ");
} }
const _c19 = function (a0) { return { "is-half": a0 }; };
const _c20 = ["nwb-sort-header", ""];
function NwbTabComponent_ng_content_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0, 0, ["*ngIf", "isSelected"]);
} }
function NwbTabsComponent_li_2_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 3);
    ɵngcc0.ɵɵelement(1, "i");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const tab_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMap(tab_r1.icon);
} }
function NwbTabsComponent_li_2_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 1);
    ɵngcc0.ɵɵlistener("click", function NwbTabsComponent_li_2_Template_li_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r5); const tab_r1 = ctx.$implicit; const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.select(tab_r1.index); });
    ɵngcc0.ɵɵelementStart(1, "a");
    ɵngcc0.ɵɵtemplate(2, NwbTabsComponent_li_2_span_2_Template, 2, 3, "span", 2);
    ɵngcc0.ɵɵelementStart(3, "span");
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const tab_r1 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(3, _c0, ctx_r0.selectedIndex === tab_r1.index));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", tab_r1.icon);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(tab_r1.label);
} }
const _c21 = ["ngWiziDatePicker"];
class NwbSpinnerComponent {
    constructor() {
        this.availableColors = ['#a2c739', '#dbdbdb', '#00d1b2', '#4baed0'];
    }
    ngOnInit() {
        if (!this.color) {
            this.color = this.availableColors[Math.floor(Math.random() * this.availableColors.length)];
        }
    }
}
NwbSpinnerComponent.ɵfac = function NwbSpinnerComponent_Factory(t) { return new (t || NwbSpinnerComponent)(); };
NwbSpinnerComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: NwbSpinnerComponent, selectors: [["nwb-spinner"]], hostAttrs: [1, "nwb-spinner"], inputs: { color: "color" }, decls: 1, vars: 2, consts: [[1, "is-spinning"]], template: function NwbSpinnerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵstyleProp("border-color", ctx.color);
    } }, encapsulation: 2 });
NwbSpinnerComponent.propDecorators = {
    color: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NwbSpinnerComponent, [{
        type: Component,
        args: [{
                selector: 'nwb-spinner',
                template: "<div class=\"is-spinning\"\n      [style.borderColor]=\"color\"\n></div>\n",
                host: {
                    class: 'nwb-spinner'
                },
                encapsulation: ViewEncapsulation.None
            }]
    }], function () { return []; }, { color: [{
            type: Input
        }] }); })();

class NwbDebounceDirective {
    constructor(elementRef) {
        this.elementRef = elementRef;
        this.nwbDebounceDelay = 700;
        this.nwbDebounceChange = new EventEmitter();
    }
    writeValue(value) {
        if (this._timerId) {
            clearTimeout(this._timerId);
        }
        this._inputValue = value;
        if (this.elementRef.nativeElement.value !== value) {
            this.elementRef.nativeElement.value = value;
        }
    }
    registerOnChange(fn) {
        this._onChanged = fn;
    }
    registerOnTouched(fn) {
        this._onTouched = fn;
    }
    ngOnInit() {
        this._inputValue = this.elementRef.nativeElement.value;
        const eventStreamKeyUp = fromEvent(this.elementRef.nativeElement, 'keyup').pipe(map(() => this.elementRef.nativeElement.value));
        this._eventStreamKeyUp = eventStreamKeyUp.subscribe((input) => this.valueChange(input));
        const eventStreamChange = fromEvent(this.elementRef.nativeElement, 'change').pipe(map(() => this.elementRef.nativeElement.value));
        this._eventStreamChange = eventStreamChange.subscribe((input) => this.valueChange(input));
    }
    ngOnDestroy() {
        this._eventStreamKeyUp.unsubscribe();
        this._eventStreamChange.unsubscribe();
    }
    valueChange(value) {
        if (this._timerId) {
            clearTimeout(this._timerId);
        }
        this._timerId = setTimeout(() => {
            if (this._inputValue !== value) {
                this._inputValue = value;
                this.nwbDebounceChange.emit(value);
                if (this._modelValue !== this._inputValue) {
                    this._modelValue = this._inputValue;
                    if (typeof this._onChanged === 'function') {
                        this._onChanged(this._inputValue);
                    }
                }
            }
        }, this.nwbDebounceDelay);
    }
}
NwbDebounceDirective.ɵfac = function NwbDebounceDirective_Factory(t) { return new (t || NwbDebounceDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
NwbDebounceDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: NwbDebounceDirective, selectors: [["", "nwbDebounce", ""]], inputs: { nwbDebounceDelay: "nwbDebounceDelay" }, outputs: { nwbDebounceChange: "nwbDebounceChange" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: NwbDebounceDirective,
                multi: true
            }
        ])] });
NwbDebounceDirective.ctorParameters = () => [
    { type: ElementRef }
];
NwbDebounceDirective.propDecorators = {
    nwbDebounceDelay: [{ type: Input }],
    nwbDebounceChange: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NwbDebounceDirective, [{
        type: Directive,
        args: [{
                selector: '[nwbDebounce]',
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: NwbDebounceDirective,
                        multi: true
                    }
                ]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { nwbDebounceDelay: [{
            type: Input
        }], nwbDebounceChange: [{
            type: Output
        }] }); })();

class NwbToolTipDirective {
    constructor(el) {
        this.el = el;
        this.el.nativeElement.classList.add('tooltip');
    }
    set nwbToolTip(value) {
        this.el.nativeElement.setAttribute('data-tooltip', value);
    }
    set nwbToolTipPosition(value) {
        this.el.nativeElement.classList.remove('is-tooltip-top');
        this.el.nativeElement.classList.remove('is-tooltip-left');
        this.el.nativeElement.classList.remove('is-tooltip-right');
        this.el.nativeElement.classList.remove('is-tooltip-bottom');
        this.el.nativeElement.classList.add('is-tooltip-' + value);
    }
    set nwbToolTipIsMultiline(value) {
        if (value) {
            this.el.nativeElement.classList.add('is-tooltip-multiline');
        }
        else {
            this.el.nativeElement.classList.remove('is-tooltip-multiline');
        }
    }
}
NwbToolTipDirective.ɵfac = function NwbToolTipDirective_Factory(t) { return new (t || NwbToolTipDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
NwbToolTipDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: NwbToolTipDirective, selectors: [["", "nwbToolTip", ""]], inputs: { nwbToolTip: "nwbToolTip", nwbToolTipPosition: "nwbToolTipPosition", nwbToolTipIsMultiline: "nwbToolTipIsMultiline" } });
NwbToolTipDirective.ctorParameters = () => [
    { type: ElementRef }
];
NwbToolTipDirective.propDecorators = {
    nwbToolTip: [{ type: Input }],
    nwbToolTipPosition: [{ type: Input }],
    nwbToolTipIsMultiline: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NwbToolTipDirective, [{
        type: Directive,
        args: [{
                selector: '[nwbToolTip]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { nwbToolTip: [{
            type: Input
        }], nwbToolTipPosition: [{
            type: Input
        }], nwbToolTipIsMultiline: [{
            type: Input
        }] }); })();

class NwbFilterGroup {
    constructor(name, group) {
        this.name = name;
        this.valuesChange$ = new Subject();
        this.group = new Map();
        Object.keys(group).forEach(key => {
            const value = group[key];
            const filter = new NwbFilter(key, value, value);
            this.group.set(key, filter);
        });
    }
    set(key, value) {
        if (this._valueChange(key, value)) {
            this.emitChange();
        }
    }
    get(key) {
        if (!this.group.has(key)) {
            throw new Error(`FilterGroup: They key ${key} doesn't exist`);
        }
        return this.group.get(key).value;
    }
    setValues(values) {
        let valueHasChanged = false;
        Object.keys(values).forEach(key => {
            if (this._valueChange(key, values[key])) {
                valueHasChanged = true;
            }
        });
        if (valueHasChanged) {
            this.emitChange();
        }
    }
    _valueChange(key, value) {
        if (!this.group.has(key)) {
            throw new Error(`FilterGroup: They key ${key} doesn't exist`);
        }
        if (typeof value === 'string') {
            value = value.trim();
        }
        if (this.group.get(key).value != value) {
            this.group.get(key).value = value;
            return true;
        }
        return false;
    }
    emitChange() {
        const filters = [];
        this.group.forEach(filter => filters.push(filter));
        this.valuesChange$.next(filters);
    }
    getFilters() {
        const filters = [];
        this.group.forEach(filter => filters.push(filter));
        return filters;
    }
}
class NwbFilter {
    constructor(key, defaultValue, value) {
        this.key = key;
        this.defaultValue = defaultValue;
        this.value = value;
    }
    isDefaultValue() {
        return this.defaultValue === this.value;
    }
}

const FILTER_GROUP_PARAM_PREFIX = 'fg_';
class NwbFilterRoutingBuilder {
    constructor(router, route) {
        this.router = router;
        this.route = route;
        this.groupCounter = 0;
        this.filterGroups = new Map();
        this.route.queryParams.subscribe(params => {
            this.queryParamsChange(params);
        });
    }
    queryParamsChange(params) {
        const groupChanges = new Map();
        Object.keys(params).forEach(key => {
            const parsedKeys = this.getParsedKey(key);
            const values = groupChanges.has(parsedKeys.filterGroupName) ? groupChanges.get(parsedKeys.filterGroupName) : {};
            values[parsedKeys.filterKey] = params[key];
            groupChanges.set(parsedKeys.filterGroupName, values);
        });
        this.filterGroups.forEach(filterGroup => {
            const defaultValues = {};
            filterGroup.getFilters().forEach(filter => {
                defaultValues[filter.key] = filter.defaultValue;
            });
            const newValues = groupChanges.has(filterGroup.name) ? groupChanges.get(filterGroup.name) : {};
            filterGroup.setValues(Object.assign(defaultValues, newValues));
        });
    }
    group(group, groupName) {
        if (!groupName) {
            groupName = `${FILTER_GROUP_PARAM_PREFIX}${this.groupCounter++}`;
        }
        const filterGroup = new NwbFilterGroup(groupName, group);
        this.filterGroups.set(filterGroup.name, filterGroup);
        filterGroup.valuesChange$.subscribe(filters => {
            this.updateRouting(filterGroup.name, filters);
        });
        // Check values from query parameters
        this.route.queryParams
            .subscribe(params => {
            this.queryParamsChange(params);
        })
            .unsubscribe();
        return filterGroup;
    }
    addFilterGroupNameToQueryParamKey(filterGroupName, key) {
        return filterGroupName + ':' + key;
    }
    getParsedKey(encodedKey) {
        const value = encodedKey.split(':');
        const filterGroupName = value[0];
        const filterKey = value[1];
        return { filterGroupName, filterKey };
    }
    updateRouting(filterGroupName, filters) {
        this.route.queryParamMap
            .subscribe(paramsMap => {
            const params = {};
            paramsMap.keys.forEach(key => {
                params[key] = paramsMap.get(key);
            });
            const queryParams = Object.assign({}, params);
            filters.forEach(filter => {
                const paramKey = this.addFilterGroupNameToQueryParamKey(filterGroupName, filter.key);
                if (!filter.isDefaultValue()) {
                    let value = filter.value;
                    if (value instanceof Date) {
                        value = value.toISOString();
                    }
                    queryParams[paramKey] = value;
                }
                else {
                    if (queryParams.hasOwnProperty(paramKey)) {
                        delete queryParams[paramKey];
                    }
                }
            });
            this.router.navigate([], {
                queryParams: queryParams,
                relativeTo: this.route
            });
        })
            .unsubscribe();
    }
    remove(filterGroup) {
        if (this.filterGroups.has(filterGroup.name)) {
            this.filterGroups.delete(filterGroup.name);
        }
    }
}
NwbFilterRoutingBuilder.ɵfac = function NwbFilterRoutingBuilder_Factory(t) { return new (t || NwbFilterRoutingBuilder)(ɵngcc0.ɵɵinject(ɵngcc1.Router), ɵngcc0.ɵɵinject(ɵngcc1.ActivatedRoute)); };
NwbFilterRoutingBuilder.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: NwbFilterRoutingBuilder, factory: NwbFilterRoutingBuilder.ɵfac });
NwbFilterRoutingBuilder.ctorParameters = () => [
    { type: Router },
    { type: ActivatedRoute }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NwbFilterRoutingBuilder, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.Router }, { type: ɵngcc1.ActivatedRoute }]; }, null); })();

class SafeHtmlPipe {
    constructor(sanitized) {
        this.sanitized = sanitized;
    }
    transform(value) {
        return this.sanitized.bypassSecurityTrustHtml(value);
    }
}
SafeHtmlPipe.ɵfac = function SafeHtmlPipe_Factory(t) { return new (t || SafeHtmlPipe)(ɵngcc0.ɵɵdirectiveInject(ɵngcc2.DomSanitizer)); };
SafeHtmlPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "safeHtml", type: SafeHtmlPipe, pure: true });
SafeHtmlPipe.ctorParameters = () => [
    { type: DomSanitizer }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SafeHtmlPipe, [{
        type: Pipe,
        args: [{ name: 'safeHtml' }]
    }], function () { return [{ type: ɵngcc2.DomSanitizer }]; }, null); })();

/**
 * The OverlayContainer is the container in which all overlays will load.
 * It should be provided in the root component to ensure it is properly shared.
 */
class OverlayContainer {
    /**
     * This method returns the overlay container element.  It will lazily
     * create the element the first time  it is called to facilitate using
     * the container in non-browser environments.
     * @returns the container element
     */
    getContainerElement() {
        if (!this._containerElement) {
            this._createContainer();
        }
        return this._containerElement;
    }
    /**
     * Create the overlay container element, which is simply a div
     * with the 'cdk-overlay-container' class on the document body.
     */
    _createContainer() {
        let container = document.createElement('div');
        container.classList.add('nwb-overlay-container');
        document.body.appendChild(container);
        this._containerElement = container;
    }
}
OverlayContainer.ɵfac = function OverlayContainer_Factory(t) { return new (t || OverlayContainer)(); };
OverlayContainer.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: OverlayContainer, factory: OverlayContainer.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OverlayContainer, [{
        type: Injectable
    }], null, null); })();
function OVERLAY_CONTAINER_PROVIDER_FACTORY(parentContainer) {
    return parentContainer || new OverlayContainer();
}
const OVERLAY_CONTAINER_PROVIDER = {
    // If there is already an OverlayContainer available, use that. Otherwise, provide a new one.
    provide: OverlayContainer,
    deps: [[new Optional(), new SkipSelf(), OverlayContainer]],
    useFactory: OVERLAY_CONTAINER_PROVIDER_FACTORY
};

class DomService {
    constructor(componentFactoryResolver, appRef, injector, overlayContainer) {
        this.componentFactoryResolver = componentFactoryResolver;
        this.appRef = appRef;
        this.injector = injector;
        this.overlayContainer = overlayContainer;
    }
    attachComponentPortal(component, injector) {
        const componentRef = this.componentFactoryResolver
            .resolveComponentFactory(component)
            .create(injector ? injector : this.injector);
        this.appRef.attachView(componentRef.hostView);
        this.overlayContainer.getContainerElement().appendChild(this._getComponentRootNode(componentRef));
        return componentRef;
    }
    /** Gets the root HTMLElement for an instantiated component. */
    _getComponentRootNode(componentRef) {
        return componentRef.hostView.rootNodes[0];
    }
}
DomService.ɵfac = function DomService_Factory(t) { return new (t || DomService)(ɵngcc0.ɵɵinject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵinject(ɵngcc0.ApplicationRef), ɵngcc0.ɵɵinject(ɵngcc0.Injector), ɵngcc0.ɵɵinject(OverlayContainer)); };
DomService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DomService, factory: DomService.ɵfac });
DomService.ctorParameters = () => [
    { type: ComponentFactoryResolver },
    { type: ApplicationRef },
    { type: Injector },
    { type: OverlayContainer }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DomService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc0.ComponentFactoryResolver }, { type: ɵngcc0.ApplicationRef }, { type: ɵngcc0.Injector }, { type: OverlayContainer }]; }, null); })();
function DOM_SERVICE_PROVIDER_FACTORY(parentContainer, componentFactoryResolver, appRef, injector, overlayContainer) {
    return parentContainer || new DomService(componentFactoryResolver, appRef, injector, overlayContainer);
}
const DOM_SERVICE_PROVIDER = {
    // If there is already an DomService available, use that. Otherwise, provide a new one.
    provide: DomService,
    deps: [[new Optional(), new SkipSelf(), DomService], ComponentFactoryResolver, ApplicationRef, Injector, OverlayContainer],
    useFactory: DOM_SERVICE_PROVIDER_FACTORY
};

class NwbCommonModule {
}
NwbCommonModule.ɵfac = function NwbCommonModule_Factory(t) { return new (t || NwbCommonModule)(); };
NwbCommonModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: NwbCommonModule });
NwbCommonModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ providers: [OVERLAY_CONTAINER_PROVIDER, DOM_SERVICE_PROVIDER, NwbFilterRoutingBuilder], imports: [[CommonModule, FormsModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NwbCommonModule, { declarations: function () { return [NwbSpinnerComponent, NwbDebounceDirective, NwbToolTipDirective, SafeHtmlPipe]; }, imports: function () { return [CommonModule, FormsModule]; }, exports: function () { return [NwbSpinnerComponent, NwbDebounceDirective, NwbToolTipDirective, SafeHtmlPipe]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NwbCommonModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, FormsModule],
                providers: [OVERLAY_CONTAINER_PROVIDER, DOM_SERVICE_PROVIDER, NwbFilterRoutingBuilder],
                entryComponents: [],
                declarations: [NwbSpinnerComponent, NwbDebounceDirective, NwbToolTipDirective, SafeHtmlPipe],
                exports: [NwbSpinnerComponent, NwbDebounceDirective, NwbToolTipDirective, SafeHtmlPipe]
            }]
    }], null, null); })();

class NwbAlertComponent {
    constructor() {
        /** Subject for notifying the user that the dialog has finished closing. */
        this._afterClosed = new Subject();
        this.open = false;
    }
    ngOnInit() {
        setTimeout(() => {
            this.open = true;
        }, 50);
        if (this.config.duration > 0) {
            this.timer = setTimeout(() => this.dismiss(), this.config.duration);
        }
    }
    dismiss() {
        this.open = false;
        setTimeout(() => {
            this._afterClosed.next(true);
            this._afterClosed.complete();
        }, 200);
    }
    /**
     * Gets an observable that is notified when the dialog is finished closing.
     */
    afterClosed() {
        return this._afterClosed.asObservable();
    }
}
NwbAlertComponent.ɵfac = function NwbAlertComponent_Factory(t) { return new (t || NwbAlertComponent)(); };
NwbAlertComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: NwbAlertComponent, selectors: [["nwb-alert"]], hostAttrs: [1, "nwb-alert"], decls: 4, vars: 7, consts: [[3, "ngClass"], [1, "alert--message"], ["class", "icon", 4, "ngIf"], [3, "innerHTML"], [1, "icon"]], template: function NwbAlertComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵtemplate(2, NwbAlertComponent_span_2_Template, 2, 2, "span", 2);
        ɵngcc0.ɵɵelement(3, "p", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMap("alert " + (ctx.config.color ? ctx.config.color : " is-primary") + (ctx.config.extraClasses ? " " + ctx.config.extraClasses : "") + (ctx.config.position ? " " + ctx.config.position : ""));
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(5, _c0, ctx.open));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.config.icon);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("innerHTML", ctx.config.message, ɵngcc0.ɵɵsanitizeHtml);
    } }, directives: [ɵngcc3.NgClass, ɵngcc3.NgIf], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NwbAlertComponent, [{
        type: Component,
        args: [{
                selector: 'nwb-alert',
                template: "<div\n  [class]=\"'alert ' + ((config.color) ? config.color : ' is-primary') + ((config.extraClasses) ? ' ' + config.extraClasses : '') + ((config.position) ? ' ' + config.position : '')\"\n  [ngClass]=\"{'is-active': open}\"\n>\n  <div class=\"alert--message\">\n      <span class=\"icon\" *ngIf=\"config.icon\">\n          <i [class]=\"config.icon\"></i>\n      </span>\n    <p [innerHTML]=\"config.message\"></p>\n  </div>\n</div>\n",
                host: {
                    class: 'nwb-alert'
                },
                encapsulation: ViewEncapsulation.None
            }]
    }], function () { return []; }, null); })();

class NwbAlertService {
    constructor(domService) {
        this.domService = domService;
    }
    open(config) {
        const componentRef = this.getComponentRef(config);
        return componentRef.instance;
    }
    getComponentRef(config) {
        const componentRef = this.domService.attachComponentPortal(NwbAlertComponent);
        config = Object.assign({
            position: 'is-top'
        }, config);
        componentRef.instance.config = config;
        componentRef.instance.afterClosed().subscribe(() => {
            componentRef.destroy();
        });
        return componentRef;
    }
}
NwbAlertService.ɵfac = function NwbAlertService_Factory(t) { return new (t || NwbAlertService)(ɵngcc0.ɵɵinject(DomService)); };
NwbAlertService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: NwbAlertService, factory: NwbAlertService.ɵfac });
NwbAlertService.ctorParameters = () => [
    { type: DomService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NwbAlertService, [{
        type: Injectable
    }], function () { return [{ type: DomService }]; }, null); })();

class NwbAlertModule {
}
NwbAlertModule.ɵfac = function NwbAlertModule_Factory(t) { return new (t || NwbAlertModule)(); };
NwbAlertModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: NwbAlertModule });
NwbAlertModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ providers: [NwbAlertService], imports: [[CommonModule, NwbCommonModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NwbAlertModule, { declarations: function () { return [NwbAlertComponent]; }, imports: function () { return [CommonModule, NwbCommonModule]; }, exports: function () { return [NwbAlertComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NwbAlertModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, NwbCommonModule],
                providers: [NwbAlertService],
                entryComponents: [NwbAlertComponent],
                declarations: [NwbAlertComponent],
                exports: [NwbAlertComponent]
            }]
    }], null, null); })();

class NwbAnimatedCardComponent {
    constructor(elementRef) {
        this.elementRef = elementRef;
        this.elementRef.nativeElement.classList.toggle('is-animate');
        if (this.elementRef.nativeElement.getAttribute('nwbAnimatedCardOpened') !== null) {
            this.elementRef.nativeElement.classList.toggle('is-active');
        }
    }
    ngOnInit() {
        this.elementRef.nativeElement.querySelector('header').addEventListener('click', () => {
            this.elementRef.nativeElement.classList.toggle('is-active');
        });
    }
}
NwbAnimatedCardComponent.ɵfac = function NwbAnimatedCardComponent_Factory(t) { return new (t || NwbAnimatedCardComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
NwbAnimatedCardComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: NwbAnimatedCardComponent, selectors: [["div", "nwbAnimatedCardClosed", ""], ["div", "nwbAnimatedCardOpened", ""]], attrs: _c1, ngContentSelectors: _c2, decls: 1, vars: 0, template: function NwbAnimatedCardComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2 });
NwbAnimatedCardComponent.ctorParameters = () => [
    { type: ElementRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NwbAnimatedCardComponent, [{
        type: Component,
        args: [{
                selector: 'div[nwbAnimatedCardClosed], div[nwbAnimatedCardOpened]',
                template: `
    <ng-content></ng-content>
  `,
                encapsulation: ViewEncapsulation.None
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, null); })();

class NwbAnimatedCardModule {
}
NwbAnimatedCardModule.ɵfac = function NwbAnimatedCardModule_Factory(t) { return new (t || NwbAnimatedCardModule)(); };
NwbAnimatedCardModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: NwbAnimatedCardModule });
NwbAnimatedCardModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ providers: [], imports: [[CommonModule, NwbCommonModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NwbAnimatedCardModule, { declarations: function () { return [NwbAnimatedCardComponent]; }, imports: function () { return [CommonModule, NwbCommonModule]; }, exports: function () { return [NwbAnimatedCardComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NwbAnimatedCardModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, NwbCommonModule],
                providers: [],
                entryComponents: [],
                declarations: [NwbAnimatedCardComponent],
                exports: [NwbAnimatedCardComponent]
            }]
    }], null, null); })();

class NwbDialogComponent {
    constructor(componentFactoryResolver) {
        this.componentFactoryResolver = componentFactoryResolver;
        this.ready = new EventEmitter();
        this.hasComponent = false;
        /** Subject for notifying the user that the dialog has finished closing. */
        this._afterClosed = new Subject();
        this.open = false;
        this.fromOkButton = false;
    }
    ngOnInit() {
        this.open = true;
        this.ready.next(true);
    }
    _keypress() {
        if (this.config.hasBackdrop) {
            this.dismiss(false);
        }
    }
    /** Method to call when backdrop button is clicked */
    backdropHandler() {
        if (this.config.hasBackdrop) {
            this.dismiss(false);
        }
    }
    /** Method to call when cancel button is clicked */
    cancelHandler() {
        if (this.config.cancelHandler && typeof this.config.cancelHandler === 'function') {
            this.config.cancelHandler();
        }
        else {
            this.dismiss(false);
        }
    }
    /** Method to call when ok button is clicked */
    okHandler() {
        if (this.config.okHandler && typeof this.config.okHandler === 'function') {
            this.config.okHandler();
        }
        else {
            this.dismiss(true);
        }
    }
    /** Gonna disable all buttons and make the ok button loading */
    disableButtonsAndMakeOkButtonLoading() {
        if (this.cancelButtonEl) {
            this.cancelButtonEl.nativeElement.setAttribute('disabled', 'disabled');
        }
        if (this.okButtonEl) {
            this.okButtonEl.nativeElement.setAttribute('disabled', 'disabled');
            this.okButtonEl.nativeElement.classList.add('is-loading');
        }
        if (this.backdropButtonEl) {
            this.backdropButtonEl.nativeElement.setAttribute('disabled', 'disabled');
        }
    }
    /** Gonna enable all buttons and make the ok button not loading */
    enableButtonsAndMakeOkButtonNotLoading() {
        if (this.cancelButtonEl) {
            this.cancelButtonEl.nativeElement.removeAttribute('disabled');
        }
        if (this.okButtonEl) {
            this.okButtonEl.nativeElement.removeAttribute('disabled');
            this.okButtonEl.nativeElement.classList.remove('is-loading');
        }
        if (this.backdropButtonEl) {
            this.backdropButtonEl.nativeElement.removeAttribute('disabled');
        }
    }
    /** Dismiss the dialog */
    dismiss(fromOkButton) {
        this.open = false;
        this.fromOkButton = fromOkButton;
    }
    animationDone(event) {
        if (event.fromState === 'active' && event.toState === 'inactive') {
            this._afterClosed.next(this.fromOkButton);
            this._afterClosed.complete();
        }
    }
    /**
     * Gets an observable that is notified when the dialog is finished closing.
     */
    afterClosed() {
        return this._afterClosed.asObservable();
    }
    hideSpinner() {
        this.config.loading = false;
    }
    displaySpinner() {
        this.config.loading = true;
    }
    _setComponent(componentOrTemplateRef) {
        let factory;
        if (componentOrTemplateRef instanceof TemplateRef) {
            this.componentSection.createEmbeddedView(componentOrTemplateRef);
        }
        else {
            factory = this.componentFactoryResolver.resolveComponentFactory(componentOrTemplateRef);
            const componentRef = this.componentSection.createComponent(factory);
            this.componentInstance = componentRef.instance;
        }
        this.hasComponent = true;
    }
}
NwbDialogComponent.ɵfac = function NwbDialogComponent_Factory(t) { return new (t || NwbDialogComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver)); };
NwbDialogComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: NwbDialogComponent, selectors: [["nwb-dialog"]], viewQuery: function NwbDialogComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c3, 3, ViewContainerRef);
        ɵngcc0.ɵɵviewQuery(_c4, 1);
        ɵngcc0.ɵɵviewQuery(_c5, 1);
        ɵngcc0.ɵɵviewQuery(_c6, 1);
        ɵngcc0.ɵɵviewQuery(_c7, 1);
        ɵngcc0.ɵɵviewQuery(_c8, 1);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.componentSection = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.okButtonEl = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.cancelButtonEl = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.backdropButtonEl = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.headerEl = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.footerEl = _t.first);
    } }, hostAttrs: [1, "nwb-dialog"], hostBindings: function NwbDialogComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("keydown.escape", function NwbDialogComponent_keydown_escape_HostBindingHandler() { return ctx._keypress(); }, false, ɵngcc0.ɵɵresolveDocument);
    } }, decls: 10, vars: 11, consts: [[1, "modal", "is-active"], [1, "modal-background", 3, "click"], [1, "modal-card", 3, "ngStyle"], ["class", "modal-card-head", 4, "ngIf"], ["class", "modal-card-body", 4, "ngIf"], ["class", "modal-card-body", 3, "innerHTML", 4, "ngIf"], [1, "modal-card-body", 3, "ngClass"], ["componentSection", ""], ["class", "modal-card-foot", 4, "ngIf"], [1, "modal-card-head"], ["header", ""], [1, "modal-card-title"], ["class", "delete", 3, "click", 4, "ngIf"], [1, "delete", 3, "click"], ["backdropButton", ""], [1, "modal-card-body"], [1, "modal-card-body", 3, "innerHTML"], [1, "modal-card-foot"], ["footer", ""], ["class", "button column is-medium is-danger is-4", 3, "click", 4, "ngIf"], ["class", "button column is-medium is-success is-offset-4", 3, "click", 4, "ngIf"], [1, "button", "column", "is-medium", "is-danger", "is-4", 3, "click"], ["cancelButton", ""], [1, "button", "column", "is-medium", "is-success", "is-offset-4", 3, "click"], ["okButton", ""]], template: function NwbDialogComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵlistener("click", function NwbDialogComponent_Template_div_click_1_listener() { return ctx.backdropHandler(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵlistener("@modalState.done", function NwbDialogComponent_Template_div_animation_modalState_done_2_listener($event) { return ctx.animationDone($event); });
        ɵngcc0.ɵɵtemplate(3, NwbDialogComponent_header_3_Template, 5, 2, "header", 3);
        ɵngcc0.ɵɵtemplate(4, NwbDialogComponent_section_4_Template, 2, 0, "section", 4);
        ɵngcc0.ɵɵtemplate(5, NwbDialogComponent_section_5_Template, 1, 1, "section", 5);
        ɵngcc0.ɵɵelementStart(6, "section", 6);
        ɵngcc0.ɵɵelement(7, "div", null, 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(9, NwbDialogComponent_footer_9_Template, 4, 2, "footer", 8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("@modalState", ctx.open ? "active" : "inactive")("ngStyle", ɵngcc0.ɵɵpureFunction1(7, _c9, ctx.config.width));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.config.title);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.config.loading);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.config.loading && ctx.config.message && ctx.config.message.length > 0);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(9, _c10, !ctx.hasComponent || ctx.config.loading));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.config.loading && (ctx.config.cancelButtonText.length > 0 || ctx.config.okButtonText.length > 0));
    } }, directives: [ɵngcc3.NgStyle, ɵngcc3.NgIf, ɵngcc3.NgClass, NwbSpinnerComponent], encapsulation: 2, data: { animation: [
            trigger('modalState', [
                transition('void => active', animate('200ms', keyframes([style({ opacity: '0', top: '5%', offset: 0 }), style({ opacity: '1', top: '0', offset: 1 })]))),
                transition('active => inactive', animate('200ms', keyframes([style({ opacity: '1', offset: 0 }), style({ opacity: '0', top: '5%', offset: 1 })])))
            ])
        ] } });
NwbDialogComponent.ctorParameters = () => [
    { type: ComponentFactoryResolver }
];
NwbDialogComponent.propDecorators = {
    componentSection: [{ type: ViewChild, args: ['componentSection', { read: ViewContainerRef, static: true },] }],
    okButtonEl: [{ type: ViewChild, args: ['okButton',] }],
    cancelButtonEl: [{ type: ViewChild, args: ['cancelButton',] }],
    backdropButtonEl: [{ type: ViewChild, args: ['backdropButton',] }],
    headerEl: [{ type: ViewChild, args: ['header',] }],
    footerEl: [{ type: ViewChild, args: ['footer',] }],
    _keypress: [{ type: HostListener, args: ['document:keydown.escape',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NwbDialogComponent, [{
        type: Component,
        args: [{
                selector: 'nwb-dialog',
                template: "<div class=\"modal is-active\">\n  <div class=\"modal-background\" (click)=\"backdropHandler()\"></div>\n  <div class=\"modal-card\"\n       [@modalState]=\"open? 'active' : 'inactive'\"\n       (@modalState.done)=\"animationDone($event)\"\n       [ngStyle]=\"{'width': config.width}\"\n  >\n    <header class=\"modal-card-head\" *ngIf=\"config.title\" #header>\n      <p class=\"modal-card-title\">{{config.title}}</p>\n      <button *ngIf=\"config.hasBackdrop\" class=\"delete\" (click)=\"backdropHandler()\" #backdropButton></button>\n    </header>\n\n    <section *ngIf=\"config.loading\" class=\"modal-card-body\">\n      <nwb-spinner></nwb-spinner>\n    </section>\n\n    <section class=\"modal-card-body\"\n             *ngIf=\"!config.loading && config.message && config.message.length > 0\" [innerHTML]=\"config.message\">\n    </section>\n\n    <section class=\"modal-card-body\" [ngClass]=\"{'is-hidden':!hasComponent || config.loading}\">\n      <div #componentSection></div>\n    </section>\n\n    <footer class=\"modal-card-foot\"\n            *ngIf=\"!config.loading && (config.cancelButtonText.length > 0 || config.okButtonText.length > 0)\" #footer>\n      <button class=\"button column is-medium is-danger is-4\" *ngIf=\"config.cancelButtonText\"\n              (click)=\"cancelHandler()\" #cancelButton>{{config.cancelButtonText}}\n      </button>\n      <button class=\"button column is-medium is-success is-offset-4\" *ngIf=\"config.okButtonText\"\n              (click)=\"okHandler()\" #okButton>{{config.okButtonText}}\n      </button>\n    </footer>\n  </div>\n</div>\n",
                host: {
                    class: 'nwb-dialog'
                },
                encapsulation: ViewEncapsulation.None,
                animations: [
                    trigger('modalState', [
                        transition('void => active', animate('200ms', keyframes([style({ opacity: '0', top: '5%', offset: 0 }), style({ opacity: '1', top: '0', offset: 1 })]))),
                        transition('active => inactive', animate('200ms', keyframes([style({ opacity: '1', offset: 0 }), style({ opacity: '0', top: '5%', offset: 1 })])))
                    ])
                ]
            }]
    }], function () { return [{ type: ɵngcc0.ComponentFactoryResolver }]; }, { _keypress: [{
            type: HostListener,
            args: ['document:keydown.escape']
        }], componentSection: [{
            type: ViewChild,
            args: ['componentSection', { read: ViewContainerRef, static: true }]
        }], okButtonEl: [{
            type: ViewChild,
            args: ['okButton']
        }], cancelButtonEl: [{
            type: ViewChild,
            args: ['cancelButton']
        }], backdropButtonEl: [{
            type: ViewChild,
            args: ['backdropButton']
        }], headerEl: [{
            type: ViewChild,
            args: ['header']
        }], footerEl: [{
            type: ViewChild,
            args: ['footer']
        }] }); })();

/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Custom injector to be used when providing custom
 * injection tokens to components inside a portal.
 * @docs-private
 */
class PortalInjector {
    constructor(_parentInjector, _customTokens) {
        this._parentInjector = _parentInjector;
        this._customTokens = _customTokens;
    }
    get(token, notFoundValue) {
        const value = this._customTokens.get(token);
        if (typeof value !== 'undefined') {
            return value;
        }
        return this._parentInjector.get(token, notFoundValue);
    }
}

/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Extends an object with the *enumerable* and *own* properties of one or more source objects,
 * similar to Object.assign.
 *
 * @param dest The object which will have properties copied to it.
 * @param sources The source objects from which properties will be copied.
 */
function extendObject(dest, ...sources) {
    if (dest == null) {
        throw TypeError('Cannot convert undefined or null to object');
    }
    for (let source of sources) {
        if (source != null) {
            for (let key in source) {
                if (source.hasOwnProperty(key)) {
                    dest[key] = source[key];
                }
            }
        }
    }
    return dest;
}

class NwbDialogService {
    constructor(domService, injector) {
        this.domService = domService;
        this.injector = injector;
    }
    open(config) {
        const componentRef = this.getComponentRef(config);
        return componentRef.instance;
    }
    openFromComponent(componentOrTemplateRef, config) {
        const componentRef = this.getComponentRef(config);
        componentRef.instance._setComponent(componentOrTemplateRef);
        return componentRef.instance;
    }
    getComponentRef(config) {
        const injectionTokens = new WeakMap();
        injectionTokens.set(NwbDialogComponent, NwbDialogComponent);
        let injector = new PortalInjector(this.injector, injectionTokens);
        const componentRef = this.domService.attachComponentPortal(NwbDialogComponent, injector);
        componentRef.instance.config = extendObject(new NwbDialogConfig(), config);
        componentRef.instance.afterClosed().subscribe(() => {
            componentRef.destroy();
        });
        return componentRef;
    }
}
NwbDialogService.ɵfac = function NwbDialogService_Factory(t) { return new (t || NwbDialogService)(ɵngcc0.ɵɵinject(DomService), ɵngcc0.ɵɵinject(ɵngcc0.Injector)); };
NwbDialogService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: NwbDialogService, factory: NwbDialogService.ɵfac });
NwbDialogService.ctorParameters = () => [
    { type: DomService },
    { type: Injector }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NwbDialogService, [{
        type: Injectable
    }], function () { return [{ type: DomService }, { type: ɵngcc0.Injector }]; }, null); })();
class NwbDialogConfig {
    constructor() {
        /** Text of the ok button. If none the button won't be displayed */
        this.okButtonText = '';
        /** Text of the cancel button. If none the button won't be displayed */
        this.cancelButtonText = '';
        /** Width of the dialog. */
        this.width = '';
        /** Whether the dialog has a backdrop. */
        this.hasBackdrop = true;
        /** Custom method to call when ok button is clicked */
        this.okHandler = null;
        /** Custom method to call when cancel button is clicked */
        this.cancelHandler = null;
        /** Display the spinner inside the dialog **/
        this.loading = false;
    }
}

class NwbDialogModule {
}
NwbDialogModule.ɵfac = function NwbDialogModule_Factory(t) { return new (t || NwbDialogModule)(); };
NwbDialogModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: NwbDialogModule });
NwbDialogModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ providers: [NwbDialogService], imports: [[CommonModule, NwbCommonModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NwbDialogModule, { declarations: function () { return [NwbDialogComponent]; }, imports: function () { return [CommonModule, NwbCommonModule]; }, exports: function () { return [NwbDialogComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NwbDialogModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, NwbCommonModule],
                providers: [NwbDialogService],
                entryComponents: [NwbDialogComponent],
                declarations: [NwbDialogComponent],
                exports: [NwbDialogComponent]
            }]
    }], null, null); })();

/**
 * @name Option
 * @description
 * `nwb-option` is a child component of `nwb-dropdown`. Similar to the native option element, `nwb-option` can take a value and a selected property.
 *
 */
class NwbOptionComponent {
    constructor(_elementRef) {
        this._elementRef = _elementRef;
        this._selected = false;
        this._disabled = false;
        this._divider = false;
        /**
         * @output {any} Event to evaluate when option is selected.
         */
        this.nwbSelect = new EventEmitter();
    }
    /**
     * @input {boolean} If true, the user cannot interact with this element.
     */
    get disabled() {
        return this._disabled;
    }
    set disabled(val) {
        this._disabled = val;
    }
    /**
     * @input {boolean} If true, the element is selected.
     */
    get selected() {
        return this._selected;
    }
    set selected(val) {
        this._selected = val;
    }
    /**
     * @input {any} The value of the option.
     */
    get value() {
        if (this._value !== 'undefined') {
            return this._value;
        }
        return this.text;
    }
    set value(val) {
        this._value = val;
    }
    /**
     * @input {boolean} If true, the option element will be a divider.
     */
    get divider() {
        return this._divider;
    }
    set divider(val) {
        this._divider = val;
    }
    /**
     * @hidden
     */
    get text() {
        return this._elementRef.nativeElement.innerHTML;
    }
}
NwbOptionComponent.ɵfac = function NwbOptionComponent_Factory(t) { return new (t || NwbOptionComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
NwbOptionComponent.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: NwbOptionComponent, selectors: [["nwb-option"]], inputs: { disabled: "disabled", selected: "selected", value: "value", divider: "divider" }, outputs: { nwbSelect: "nwbSelect" } });
NwbOptionComponent.ctorParameters = () => [
    { type: ElementRef }
];
NwbOptionComponent.propDecorators = {
    disabled: [{ type: Input }],
    selected: [{ type: Input }],
    value: [{ type: Input }],
    divider: [{ type: Input }],
    nwbSelect: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NwbOptionComponent, [{
        type: Directive,
        args: [{
                selector: 'nwb-option'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { nwbSelect: [{
            type: Output
        }], disabled: [{
            type: Input
        }], selected: [{
            type: Input
        }], value: [{
            type: Input
        }], divider: [{
            type: Input
        }] }); })();

class NwbDropdownComponent {
    constructor(_elementRef, renderer) {
        this._elementRef = _elementRef;
        this.renderer = renderer;
        /** Set to true for align to right the dropdown */
        this.rightToLeft = false;
        /** Set to true for align to top the dropdown */
        this.isUp = false;
        this.config = {};
        this.isActive = false;
    }
    writeValue(obj) {
        this.currentValue = obj;
        this._updateOptions();
    }
    registerOnChange(fn) {
        this._onChanged = fn;
    }
    registerOnTouched(fn) {
        this._onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    documentClickOrTouch(ev) {
        if (!this._elementRef.nativeElement.contains(ev.target)) {
            // Outside host, close dropdown
            this.isActive = false;
            if (this.documentClickListenerRemover) {
                this.documentClickListenerRemover();
            }
            if (this.documentTouchstartListenerRemover) {
                this.documentTouchstartListenerRemover();
            }
        }
    }
    set options(val) {
        this._options = val;
        this._updateOptions();
    }
    _updateOptions() {
        if (this._options) {
            this._options.forEach((option) => {
                option.selected = option.value === this.currentValue;
                if (option.selected) {
                    this.currentText = option.text;
                }
            });
        }
    }
    _setValue(option) {
        if (!option.disabled && this.currentValue !== option.value) {
            option.nwbSelect.emit(option.value);
            this.currentValue = option.value;
            this._onChanged(this.currentValue);
            this._updateOptions();
        }
    }
    selectOption(option) {
        if (!option.disabled && this.currentValue !== option.value) {
            if (typeof this.config.handler === 'function') {
                this.isLoading = true;
                this.config.handler(option.value, this.config.data).subscribe((hasChanged) => {
                    this.isLoading = false;
                    if (hasChanged) {
                        this._setValue(option);
                    }
                }, () => {
                    this.isLoading = false;
                });
            }
            else {
                this._setValue(option);
            }
        }
    }
    toggleActive() {
        if (this.disabled === true || (this.isLoading && !this.isActive)) {
            return;
        }
        this.isActive = !this.isActive;
        if (this.isActive) {
            this.documentClickListenerRemover = this.renderer.listen('document', 'click', (ev) => this.documentClickOrTouch(ev));
            this.documentTouchstartListenerRemover = this.renderer.listen('document', 'touchstart', (ev) => this.documentClickOrTouch(ev));
        }
    }
}
NwbDropdownComponent.ɵfac = function NwbDropdownComponent_Factory(t) { return new (t || NwbDropdownComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
NwbDropdownComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: NwbDropdownComponent, selectors: [["nwb-dropdown"]], contentQueries: function NwbDropdownComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, NwbOptionComponent, 0);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.options = _t);
    } }, hostAttrs: [1, "nwb-dropdown"], inputs: { rightToLeft: "rightToLeft", isUp: "isUp", config: "config", disabled: "disabled", isLoading: "isLoading", classes: "classes" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: NwbDropdownComponent,
                multi: true
            },
        ])], decls: 8, vars: 14, consts: [[1, "dropdown", 3, "ngClass", "click"], [1, "dropdown-trigger"], ["aria-haspopup", "true", "aria-controls", "dropdown-menu", 3, "ngClass", "disabled"], [3, "innerHTML"], [1, "icon", "is-small"], [1, "fa", "fa-angle-down"], ["class", "dropdown-menu", "role", "menu", 4, "ngIf"], ["role", "menu", 1, "dropdown-menu"], [1, "dropdown-content"], [4, "ngFor", "ngForOf"], ["class", "dropdown-divider", 4, "ngIf"], ["class", "dropdown-item", 3, "ngClass", "innerHTML", "click", 4, "ngIf"], [1, "dropdown-divider"], [1, "dropdown-item", 3, "ngClass", "innerHTML", "click"]], template: function NwbDropdownComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵlistener("click", function NwbDropdownComponent_Template_div_click_0_listener() { return ctx.toggleActive(); });
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "button", 2);
        ɵngcc0.ɵɵelement(3, "span", 3);
        ɵngcc0.ɵɵpipe(4, "safeHtml");
        ɵngcc0.ɵɵelementStart(5, "span", 4);
        ɵngcc0.ɵɵelement(6, "i", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(7, NwbDropdownComponent_div_7_Template, 3, 1, "div", 6);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction3(7, _c12, ctx.isActive, ctx.rightToLeft, ctx.isUp));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(11, _c13, ctx.classes ? ctx.classes : "", ctx.isLoading ? " is-loading" : ""))("disabled", ctx.disabled);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("innerHTML", ɵngcc0.ɵɵpipeBind1(4, 5, ctx.currentText), ɵngcc0.ɵɵsanitizeHtml);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isActive);
    } }, directives: [ɵngcc3.NgClass, ɵngcc3.NgIf, ɵngcc3.NgForOf], pipes: [SafeHtmlPipe], encapsulation: 2 });
NwbDropdownComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 }
];
NwbDropdownComponent.propDecorators = {
    isLoading: [{ type: Input }],
    classes: [{ type: Input }],
    rightToLeft: [{ type: Input }],
    isUp: [{ type: Input }],
    disabled: [{ type: Input }],
    config: [{ type: Input }],
    options: [{ type: ContentChildren, args: [NwbOptionComponent,] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NwbDropdownComponent, [{
        type: Component,
        args: [{
                selector: 'nwb-dropdown',
                template: "<div class=\"dropdown\" [ngClass]=\"{ 'is-active': isActive, 'right-to-left': rightToLeft, 'is-up': isUp }\" (click)=\"toggleActive()\">\n  <div class=\"dropdown-trigger\">\n    <button\n      [ngClass]=\"['button', classes ? classes : '', isLoading ? ' is-loading' : '']\"\n      aria-haspopup=\"true\"\n      aria-controls=\"dropdown-menu\"\n      [disabled]=\"disabled\"\n    >\n      <span [innerHTML]=\"currentText | safeHtml\"></span>\n      <span class=\"icon is-small\">\n        <i class=\"fa fa-angle-down\"></i>\n      </span>\n    </button>\n  </div>\n  <div class=\"dropdown-menu\" role=\"menu\" *ngIf=\"isActive\">\n    <div class=\"dropdown-content\">\n      <ng-container *ngFor=\"let option of _options\">\n        <hr class=\"dropdown-divider\" *ngIf=\"option.divider\" />\n        <a\n          *ngIf=\"!option.divider\"\n          class=\"dropdown-item\"\n          [ngClass]=\"{ 'is-active': option.selected, 'is-disabled': option.disabled }\"\n          (click)=\"selectOption(option)\"\n          [innerHTML]=\"option.text | safeHtml\"\n        >\n        </a>\n      </ng-container>\n    </div>\n  </div>\n</div>\n",
                host: {
                    class: 'nwb-dropdown'
                },
                encapsulation: ViewEncapsulation.None,
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: NwbDropdownComponent,
                        multi: true
                    },
                ]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }]; }, { rightToLeft: [{
            type: Input
        }], isUp: [{
            type: Input
        }], config: [{
            type: Input
        }], disabled: [{
            type: Input
        }], options: [{
            type: ContentChildren,
            args: [NwbOptionComponent]
        }], isLoading: [{
            type: Input
        }], classes: [{
            type: Input
        }] }); })();

class NwbDropdownModule {
}
NwbDropdownModule.ɵfac = function NwbDropdownModule_Factory(t) { return new (t || NwbDropdownModule)(); };
NwbDropdownModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: NwbDropdownModule });
NwbDropdownModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ providers: [], imports: [[CommonModule, NwbCommonModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NwbDropdownModule, { declarations: function () { return [NwbDropdownComponent, NwbOptionComponent]; }, imports: function () { return [CommonModule, NwbCommonModule]; }, exports: function () { return [NwbDropdownComponent, NwbOptionComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NwbDropdownModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, NwbCommonModule],
                providers: [],
                entryComponents: [],
                declarations: [NwbDropdownComponent, NwbOptionComponent],
                exports: [NwbDropdownComponent, NwbOptionComponent]
            }]
    }], null, null); })();

class NwbEditInPlaceComponent {
    constructor() {
        this.config = {};
        this.customChange = new EventEmitter();
        this.editing = false;
        this.onChange = Function.prototype;
        this.onTouched = Function.prototype;
    }
    get value() {
        return this.currentValue;
    }
    set value(v) {
        if (v !== this.currentValue) {
            this.currentValue = v;
        }
    }
    writeValue(value) {
        if (value !== null) {
            if (this.config.currency) {
                this.currentValue = this.parseValueToNumber(value);
                if (this.config.separator !== '.') {
                    this.currentValue = this.parseValueToSeparator(this.currentValue);
                }
                this.currentValue += this.config.currency;
            }
            else {
                this.currentValue = value;
            }
        }
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    _setValue(v) {
        if (typeof this.config.currency === 'string') {
            v = this.parseValueToNumber(v);
            this.onChange(v);
            if (this.config.separator !== '.') {
                v = this.parseValueToSeparator(v);
            }
            v = v + this.config.currency;
            this.customChange.emit(v);
        }
        else {
            this.onChange(v);
        }
        this.writeValue(v);
        this.value = v;
    }
    ngAfterViewChecked() {
        if (this.input && this.editing) {
            this.input.nativeElement.focus();
            if (this.config.selectTextUponClick && this.firstEdit && this.preValue && this.input.nativeElement.value) {
                this.input.nativeElement.select();
                this.firstEdit = false;
            }
        }
        this.initialized = true;
    }
    startEditing() {
        if (!this.editing) {
            this.editing = true;
            this.currentValue = this.checkAndRemoveCurrency(this.currentValue);
            this.firstEdit = true;
        }
    }
    edit() {
        this.preValue = this.currentValue;
        this.editing = true;
    }
    onSubmit() {
        this.editing = false;
        if (this.currentValue !== this.preValue) {
            if (typeof this.config.handler === 'function') {
                this.isLoading = true;
                this.config.handler(this.currentValue, this.config.data).subscribe(data => {
                    let hasChanged;
                    this.isLoading = false;
                    if (typeof data !== 'boolean') {
                        this.currentValue = data.value;
                        hasChanged = data.success;
                    }
                    else {
                        hasChanged = data;
                    }
                    if (hasChanged) {
                        this._setValue(this.currentValue);
                    }
                    else {
                        this._setValue(this.preValue);
                    }
                }, () => {
                    this.isLoading = false;
                    this._setValue(this.preValue);
                });
            }
            else {
                this._setValue(this.currentValue);
            }
        }
        else {
            if (typeof this.config.currency === 'string') {
                this.currentValue = this.currentValue + this.config.currency;
            }
        }
    }
    checkAndRemoveCurrency(value) {
        if (typeof this.config.currency === 'string') {
            return value.slice(0, -1);
        }
        return value;
    }
    parseValueToNumber(value) {
        if (!isNaN(value) && value !== '') {
            return parseFloat(value);
        }
        if (typeof this.config.currency === 'string') {
            const indexComma = value.indexOf(',');
            const indexDot = value.indexOf('.');
            if (indexComma > 0 && indexDot === -1) {
                const parsedValue = value.replace(',', '.');
                if (!isNaN(parsedValue)) {
                    return parseFloat(parsedValue);
                }
            }
            if (indexDot > 0 && indexComma === -1) {
                if (!isNaN(value)) {
                    return parseFloat(value);
                }
            }
            return 0;
        }
    }
    parseValueToSeparator(value) {
        if (typeof this.config.separator === 'string') {
            value = parseFloat(value).toFixed(2);
            return value.replace('.', this.config.separator);
        }
        return value;
    }
    ngOnChanges(changes) {
        if (this.initialized && typeof this.config.currency === 'string') {
            this.currentValue = this.checkAndRemoveCurrency(this.currentValue) + this.config.currency;
            this.customChange.emit(this.value);
        }
    }
}
NwbEditInPlaceComponent.ɵfac = function NwbEditInPlaceComponent_Factory(t) { return new (t || NwbEditInPlaceComponent)(); };
NwbEditInPlaceComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: NwbEditInPlaceComponent, selectors: [["nwb-edit-in-place"]], viewQuery: function NwbEditInPlaceComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c14, 1);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.input = _t.first);
    } }, inputs: { config: "config" }, outputs: { customChange: "customChange" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: NwbEditInPlaceComponent,
                multi: true
            }
        ]), ɵngcc0.ɵɵNgOnChangesFeature], decls: 5, vars: 10, consts: [[1, "nwb-wrapper", 3, "click"], ["data-text", ""], ["type", "text", 3, "nwb-editable", "nwb-editing", "nwb-is-loading", "ngModel", "ngStyle", "ngModelChange", "focus", "blur", "keyup.enter", 4, "ngIf"], [1, "nwb-loader"], ["type", "text", 3, "ngModel", "ngStyle", "ngModelChange", "focus", "blur", "keyup.enter"], ["input", ""]], template: function NwbEditInPlaceComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵlistener("click", function NwbEditInPlaceComponent_Template_div_click_0_listener() { return ctx.startEditing(); });
        ɵngcc0.ɵɵelementStart(1, "span", 1);
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(3, NwbEditInPlaceComponent_input_3_Template, 2, 10, "input", 2);
        ɵngcc0.ɵɵelement(4, "span", 3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("nwb-wrapper--editable", !ctx.editing && !ctx.isLoading);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("nwb-is-loading", ctx.isLoading)("nwb-editing", ctx.editing);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.currentValue, "\n");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.editing);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("nwb-is-loading", ctx.isLoading);
    } }, directives: [ɵngcc3.NgIf, ɵngcc4.DefaultValueAccessor, ɵngcc4.NgControlStatus, ɵngcc4.NgModel, ɵngcc3.NgStyle], encapsulation: 2 });
NwbEditInPlaceComponent.propDecorators = {
    config: [{ type: Input }],
    customChange: [{ type: Output }],
    input: [{ type: ViewChild, args: ['input',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NwbEditInPlaceComponent, [{
        type: Component,
        args: [{
                selector: 'nwb-edit-in-place',
                template: "<div [class.nwb-wrapper--editable]=\"!editing && !isLoading\" class=\"nwb-wrapper\" (click)=\"startEditing()\">\n  <span\n  data-text=\"\"\n  [class.nwb-is-loading]=\"isLoading\"\n  [class.nwb-editing]=\"editing\">\n  {{currentValue}}\n</span>\n\n<input\n#input\n*ngIf=\"editing\"\n[class.nwb-editable]=\"!editing\"\n[class.nwb-editing]=\"editing\"\n[class.nwb-is-loading]=\"isLoading\"\ntype=\"text\"\n[(ngModel)]=\"value\"\n(focus)=\"edit()\"\n(blur)=\"onSubmit()\"\n(keyup.enter)=\"onSubmit()\"\n[ngStyle]=\"{'width.px': inputWidth}\"\n/>\n\n  <span class=\"nwb-loader\" [class.nwb-is-loading]=\"isLoading\"></span>\n</div>\n",
                encapsulation: ViewEncapsulation.None,
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: NwbEditInPlaceComponent,
                        multi: true
                    }
                ]
            }]
    }], function () { return []; }, { config: [{
            type: Input
        }], customChange: [{
            type: Output
        }], input: [{
            type: ViewChild,
            args: ['input']
        }] }); })();

class NwbEditInPlaceModule {
}
NwbEditInPlaceModule.ɵfac = function NwbEditInPlaceModule_Factory(t) { return new (t || NwbEditInPlaceModule)(); };
NwbEditInPlaceModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: NwbEditInPlaceModule });
NwbEditInPlaceModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ providers: [], imports: [[CommonModule, NwbCommonModule, FormsModule, ReactiveFormsModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NwbEditInPlaceModule, { declarations: function () { return [NwbEditInPlaceComponent]; }, imports: function () { return [CommonModule, NwbCommonModule, FormsModule, ReactiveFormsModule]; }, exports: function () { return [NwbEditInPlaceComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NwbEditInPlaceModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, NwbCommonModule, FormsModule, ReactiveFormsModule],
                providers: [],
                entryComponents: [],
                declarations: [NwbEditInPlaceComponent],
                exports: [NwbEditInPlaceComponent]
            }]
    }], null, null); })();

class NwbModalSearchComponent {
    constructor() {
        this.selectedValue$ = new Subject();
        this.afterViewInit$ = new EventEmitter();
        this.selectedFoundRow = 0;
        this.isActive = false;
        this.foundRows = [];
        this.isSearching = false;
        this.searchString = '';
        this.enabled = true;
        this._isMouseNavigating = false;
    }
    ngAfterViewInit() {
        this.afterViewInit$.emit();
    }
    open() {
        if (!this.enabled) {
            return;
        }
        this._reset();
        this.focusInputSearch();
        this.isActive = true;
        this.searching('');
    }
    close() {
        this.isActive = false;
        this._reset();
    }
    _reset() {
        this.foundRows = [];
        this.selectedFoundRow = 0;
        this.searchString = '';
        setTimeout(() => {
            this.inputSearch.nativeElement.value = '';
        });
    }
    inputOnKeyDown(ev) {
        if (ev.keyCode === 27) {
            // Esc
            this.close();
        }
    }
    documentOnKeyDown(ev) {
        let somethingHappened = false;
        // Avoid to select a row with the mouse over event while navigating with keyboard
        this._isMouseNavigating = false;
        somethingHappened = this.openFromKeyboard(ev) || somethingHappened;
        somethingHappened = this.keyboardNavigate(ev) || somethingHappened;
        somethingHappened = this.onEnter(ev) || somethingHappened;
        if (somethingHappened) {
            ev.preventDefault();
        }
    }
    mouseMove() {
        this._isMouseNavigating = true;
    }
    mouseOver(index) {
        if (this._isMouseNavigating) {
            this.selectedFoundRow = index;
        }
    }
    getSpecialKey(ev) {
        if (ev.metaKey) {
            return navigator.platform.match('Mac') ? 'cmd' : 'windows';
        }
        else if (ev.ctrlKey) {
            return 'ctrl';
        }
        else if (ev.shiftKey) {
            return 'shift';
        }
        else if (ev.altKey) {
            return 'alt';
        }
        return null;
    }
    isSubscribedKey(ev) {
        return (this.config.keyCodes.filter(keyCode => {
            const specialKey = this.getSpecialKey(ev);
            return specialKey === keyCode.specialKey && ev.key === keyCode.key;
        }).length > 0);
    }
    openFromKeyboard(ev) {
        if (!this.isActive && this.config && this.isSubscribedKey(ev)) {
            this.open();
            return true;
        }
        return false;
    }
    keyboardNavigate(ev) {
        const keyCode = ev.keyCode;
        if (!this.isActive) {
            return false;
        }
        let somethingHappened = false;
        if (keyCode === 40 || keyCode === 9) {
            // Up or TAB
            do {
                this.selectedFoundRow++;
                if (this.selectedFoundRow >= this.foundRows.length) {
                    this.selectedFoundRow = 0;
                }
            } while (!this.isSelectedFoundRowSelectable());
            somethingHappened = true;
        }
        else if (keyCode === 38) {
            // Down
            do {
                this.selectedFoundRow--;
                if (this.selectedFoundRow < 0) {
                    this.selectedFoundRow = this.foundRows.length - 1;
                }
            } while (!this.isSelectedFoundRowSelectable());
            somethingHappened = true;
        }
        if (somethingHappened) {
            // Make the .nwb-modal-search-found-rows with overflow scrolls
            const htmlRow = document.querySelector(`a.nwb-modal-search-row[tabindex="${this.selectedFoundRow}"`);
            if (htmlRow) {
                htmlRow.focus();
                this.focusInputSearch();
            }
        }
        return somethingHappened;
    }
    focusInputSearch() {
        setTimeout(() => {
            this.inputSearch.nativeElement.focus();
        });
    }
    onEnter(ev) {
        const keyCode = ev.keyCode;
        if (!this.isActive) {
            return false;
        }
        if (keyCode === 13) {
            // Enter
            this.selectValue();
        }
    }
    isSelectedFoundRowSelectable() {
        return this.foundRows.length > 0 && this.foundRows[this.selectedFoundRow] && this.foundRows[this.selectedFoundRow].isSelectable;
    }
    selectFirstSelectableRow() {
        if (this.foundRows.length === 0) {
            return;
        }
        this.selectedFoundRow = 0;
        while (!this.isSelectedFoundRowSelectable()) {
            this.selectedFoundRow++;
            if (this.selectedFoundRow >= this.foundRows.length) {
                this.selectedFoundRow = 0;
            }
        }
    }
    selectValue() {
        if (this.foundRows.length > 0 && this.foundRows[this.selectedFoundRow]) {
            this.selectedValue$.next(this.foundRows[this.selectedFoundRow]);
            this.close();
        }
    }
    searching(searchString) {
        if (this.searchSubscription) {
            this.searchSubscription.unsubscribe();
        }
        let obs;
        if (typeof this.config.customSearchFn === 'function') {
            obs = this.config.customSearchFn(searchString);
        }
        else if (this.config.records) {
            obs = this.searchFromRecords(searchString);
        }
        if (Array.isArray(obs)) {
            this.foundRows = this.flattenNwbFoundRow(obs);
            this.selectFirstSelectableRow();
        }
        else if (obs) {
            this.isSearching = true;
            this.searchSubscription = obs.pipe(finalize(() => (this.isSearching = false))).subscribe(foundRows => {
                this.foundRows = this.flattenNwbFoundRow(foundRows);
                this.selectFirstSelectableRow();
            });
        }
    }
    flattenNwbFoundRow(rows) {
        let foundRows = [];
        let hasSelectableRow = false;
        rows.forEach(row => {
            const foundRow = {
                text: row.text,
                isSelectable: row.hasOwnProperty('isSelectable') ? row.isSelectable : true,
                isChild: false,
                data: row.data || null,
                isParent: row.children && row.children.length > 0
            };
            if (foundRow.isSelectable) {
                hasSelectableRow = true;
            }
            foundRows.push(foundRow);
            if (row.children) {
                row.children.forEach(child => {
                    const foundRowChild = {
                        text: child.text,
                        isSelectable: child.hasOwnProperty('isSelectable') ? child.isSelectable : true,
                        isChild: true,
                        data: child.data || null,
                        isParent: false
                    };
                    if (foundRowChild.isSelectable) {
                        hasSelectableRow = true;
                    }
                    foundRows.push(foundRowChild);
                });
            }
        });
        if (!hasSelectableRow && foundRows.length > 0) {
            console.error('No selectable rows! empty found rows to avoid infinite loop');
            foundRows = [];
        }
        return foundRows;
    }
    searchFromRecords(searchValue) {
        return Observable.create((observer) => {
            const foundRows = this.searchAllWordsInFoundRows(searchValue, this.config.records);
            observer.next(foundRows);
            observer.complete();
        });
    }
    searchAllWordsInFoundRows(searchValue, rows) {
        const regExStr = searchValue
            .split(' ')
            .map(word => {
            return `(?=.*${word})`;
        })
            .join('');
        const regEx = new RegExp(regExStr, 'ig');
        const foundRows = [];
        rows.forEach(record => {
            let children = [];
            if (record.children) {
                children = record.children.filter(childRecord => childRecord.text.search(regEx) !== -1);
            }
            if (children.length || record.text.search(regEx) !== -1) {
                const row = Object.assign({}, record);
                row.children = children;
                foundRows.push(row);
            }
        });
        return foundRows;
    }
}
NwbModalSearchComponent.ɵfac = function NwbModalSearchComponent_Factory(t) { return new (t || NwbModalSearchComponent)(); };
NwbModalSearchComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: NwbModalSearchComponent, selectors: [["nwb-modal-search"]], viewQuery: function NwbModalSearchComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c7, 1);
        ɵngcc0.ɵɵviewQuery(_c16, 3);
        ɵngcc0.ɵɵviewQuery(_c8, 1);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.header = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.inputSearch = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.footer = _t.first);
    } }, hostAttrs: [1, "nwb-modal-search"], hostBindings: function NwbModalSearchComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("keydown", function NwbModalSearchComponent_keydown_HostBindingHandler($event) { return ctx.documentOnKeyDown($event); }, false, ɵngcc0.ɵɵresolveDocument);
    } }, decls: 14, vars: 19, consts: [[3, "ngClass"], [1, "modal-background", 3, "click"], [1, "modal-content", "modal-card", 3, "ngClass", "click"], ["class", "modal-card-head", 4, "ngIf"], [1, "modal-card-body", 3, "ngClass"], [1, "field", "nwb-modal-search"], [1, "control", "has-icons-left"], ["type", "text", 1, "input", 3, "ngModel", "placeholder", "ngModelChange", "keydown"], ["inputSearch", ""], [1, "icon", "is-large", "is-left"], [1, "fa", "fa-search"], ["class", "nwb-modal-search-found-rows", 4, "ngIf"], [4, "ngIf"], ["class", "modal-card-foot", 4, "ngIf"], [1, "modal-card-head"], ["header", ""], [1, "nwb-modal-search-found-rows"], ["class", "nwb-modal-search-row", 3, "ngClass", "tabindex", "mousemove", "mouseover", "click", 4, "ngFor", "ngForOf"], [1, "nwb-modal-search-row", 3, "ngClass", "tabindex", "mousemove", "mouseover", "click"], [1, "nwb-modal-search-row-content", 3, "innerHTML"], [1, "modal-card-foot"], ["footer", ""]], template: function NwbModalSearchComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵlistener("click", function NwbModalSearchComponent_Template_div_click_1_listener() { return ctx.close(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵlistener("click", function NwbModalSearchComponent_Template_div_click_2_listener() { return ctx.focusInputSearch(); });
        ɵngcc0.ɵɵtemplate(3, NwbModalSearchComponent_header_3_Template, 2, 0, "header", 3);
        ɵngcc0.ɵɵelementStart(4, "section", 4);
        ɵngcc0.ɵɵelementStart(5, "div", 5);
        ɵngcc0.ɵɵelementStart(6, "div", 6);
        ɵngcc0.ɵɵelementStart(7, "input", 7, 8);
        ɵngcc0.ɵɵlistener("ngModelChange", function NwbModalSearchComponent_Template_input_ngModelChange_7_listener($event) { return ctx.searching($event); })("keydown", function NwbModalSearchComponent_Template_input_keydown_7_listener($event) { return ctx.inputOnKeyDown($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "span", 9);
        ɵngcc0.ɵɵelement(10, "i", 10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(11, NwbModalSearchComponent_div_11_Template, 2, 1, "div", 11);
        ɵngcc0.ɵɵtemplate(12, NwbModalSearchComponent_nwb_spinner_12_Template, 1, 0, "nwb-spinner", 12);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(13, NwbModalSearchComponent_footer_13_Template, 2, 0, "footer", 13);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMapInterpolate1("modal ", ctx.config.extraClasses ? " " + ctx.config.extraClasses : "", "");
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(12, _c0, ctx.isActive));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(14, _c0, ctx.isActive));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.config.hasHeader);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(16, _c18, !ctx.config.hasHeader, !ctx.config.hasFooter));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵpropertyInterpolate("placeholder", ctx.config.inputPlaceholder);
        ɵngcc0.ɵɵproperty("ngModel", ctx.searchString);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.isSearching && ctx.foundRows.length > 0);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isSearching);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.config.hasFooter);
    } }, directives: [ɵngcc3.NgClass, ɵngcc3.NgIf, ɵngcc4.DefaultValueAccessor, ɵngcc4.NgControlStatus, ɵngcc4.NgModel, ɵngcc3.NgForOf, NwbSpinnerComponent], encapsulation: 2 });
NwbModalSearchComponent.ctorParameters = () => [];
NwbModalSearchComponent.propDecorators = {
    header: [{ type: ViewChild, args: ['header',] }],
    inputSearch: [{ type: ViewChild, args: ['inputSearch', { static: true },] }],
    footer: [{ type: ViewChild, args: ['footer',] }],
    documentOnKeyDown: [{ type: HostListener, args: ['document:keydown', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NwbModalSearchComponent, [{
        type: Component,
        args: [{
                selector: 'nwb-modal-search',
                template: "<div class=\"modal {{(config.extraClasses) ? ' ' + config.extraClasses : ''}}\" [ngClass]=\"{'is-active': isActive}\">\n  <div class=\"modal-background\" (click)=\"close()\"></div>\n  <div class=\"modal-content modal-card\" (click)=\"focusInputSearch()\" [ngClass]=\"{'is-active': isActive}\">\n    <header #header class=\"modal-card-head\" *ngIf=\"config.hasHeader\">\n    </header>\n    <section class=\"modal-card-body\" [ngClass]=\"{'has-no-header':!config.hasHeader, 'has-no-footer':!config.hasFooter}\">\n      <div class=\"field nwb-modal-search\">\n        <div class=\"control has-icons-left\">\n          <input [ngModel]=\"searchString\" (ngModelChange)=\"searching($event)\"\n                 (keydown)=\"inputOnKeyDown($event)\"\n                 #inputSearch\n                 class=\"input\"\n                 type=\"text\"\n                 placeholder=\"{{config.inputPlaceholder}}\">\n          <span class=\"icon is-large is-left\">\n        <i class=\"fa fa-search\"></i>\n      </span>\n        </div>\n        <div class=\"nwb-modal-search-found-rows\" *ngIf=\"!isSearching && foundRows.length > 0\">\n          <a *ngFor=\"let row of foundRows; let i = index\"\n             [ngClass]=\"{'selected': row.isSelectable && i === selectedFoundRow, 'not-selectable': !row.isSelectable, 'is-child':row.isChild, 'is-parent': row.isParent}\"\n             (mousemove)=\"mouseMove()\"\n             (mouseover)=\"mouseOver(i)\"\n             (click)=\"selectValue()\"\n             class=\"nwb-modal-search-row\" [tabindex]=\"i\"\n          >\n            <div class=\"nwb-modal-search-row-content\" [innerHTML]=\"row.text\"></div>\n          </a>\n        </div>\n        <nwb-spinner *ngIf=\"isSearching\"></nwb-spinner>\n      </div>\n    </section>\n    <footer #footer class=\"modal-card-foot\" *ngIf=\"config.hasFooter\">\n    </footer>\n  </div>\n</div>\n",
                host: {
                    class: 'nwb-modal-search'
                },
                encapsulation: ViewEncapsulation.None
            }]
    }], function () { return []; }, { documentOnKeyDown: [{
            type: HostListener,
            args: ['document:keydown', ['$event']]
        }], header: [{
            type: ViewChild,
            args: ['header']
        }], inputSearch: [{
            type: ViewChild,
            args: ['inputSearch', { static: true }]
        }], footer: [{
            type: ViewChild,
            args: ['footer']
        }] }); })();

class NwbModalSearchService {
    constructor(domService, injector) {
        this.domService = domService;
        this.injector = injector;
    }
    create(config) {
        const componentRef = this.getComponentRef(config);
        return componentRef.instance;
    }
    getComponentRef(config) {
        const injectionTokens = new WeakMap();
        injectionTokens.set(NwbModalSearchComponent, NwbModalSearchComponent);
        let injector = new PortalInjector(this.injector, injectionTokens);
        const componentRef = this.domService.attachComponentPortal(NwbModalSearchComponent, injector);
        componentRef.instance.config = extendObject(new NwbModalSearchConfig(), config);
        return componentRef;
    }
}
NwbModalSearchService.ɵfac = function NwbModalSearchService_Factory(t) { return new (t || NwbModalSearchService)(ɵngcc0.ɵɵinject(DomService), ɵngcc0.ɵɵinject(ɵngcc0.Injector)); };
NwbModalSearchService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: NwbModalSearchService, factory: NwbModalSearchService.ɵfac });
NwbModalSearchService.ctorParameters = () => [
    { type: DomService },
    { type: Injector }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NwbModalSearchService, [{
        type: Injectable
    }], function () { return [{ type: DomService }, { type: ɵngcc0.Injector }]; }, null); })();
class NwbModalSearchConfig {
    constructor() {
        this.hasHeader = false;
        this.hasFooter = false;
        /** keys combination to open the modal **/
        this.keyCodes = [
            {
                specialKey: 'cmd',
                key: 'k'
            },
            {
                specialKey: 'ctrl',
                key: 'k'
            }
        ];
        /** search input place holder **/
        this.inputPlaceholder = 'Jump to...';
        /** extra classes to add **/
        this.extraClasses = '';
    }
}

class NwbModalSearchModule {
}
NwbModalSearchModule.ɵfac = function NwbModalSearchModule_Factory(t) { return new (t || NwbModalSearchModule)(); };
NwbModalSearchModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: NwbModalSearchModule });
NwbModalSearchModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ providers: [NwbModalSearchService], imports: [[CommonModule, FormsModule, NwbCommonModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NwbModalSearchModule, { declarations: function () { return [NwbModalSearchComponent]; }, imports: function () { return [CommonModule, FormsModule, NwbCommonModule]; }, exports: function () { return [NwbModalSearchComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NwbModalSearchModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, FormsModule, NwbCommonModule],
                providers: [NwbModalSearchService],
                entryComponents: [NwbModalSearchComponent],
                declarations: [NwbModalSearchComponent],
                exports: [NwbModalSearchComponent]
            }]
    }], null, null); })();

/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 *
 * Copy from angular material
 *
 * To modify the labels and text displayed, create a new instance of NwbPaginatorIntl and
 * include it in a custom provider
 */
class NwbPaginatorIntl {
    constructor() {
        /**
         * Stream that emits whenever the labels here are changed. Use this to notify
         * components if the labels have changed after initialization.
         */
        this.changes = new Subject();
        /** A label for the page size selector. */
        this.itemsPerPageLabel = 'Items per page:';
        /** A label for the page size selector. */
        this.ofLabel = 'of';
        /** A label for the range of items within the current page and the length of the whole list. */
        this.getRangeLabel = (page, pageSize, length) => {
            if (length == 0 || pageSize == 0) {
                return `0 ${this.ofLabel} ${length}`;
            }
            length = Math.max(length, 0);
            const startIndex = page * pageSize;
            // If the start index exceeds the list length, do not try and fix the end index to the end.
            const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
            return `${startIndex + 1} - ${endIndex} ${this.ofLabel} ${length}`;
        };
    }
}
NwbPaginatorIntl.ɵfac = function NwbPaginatorIntl_Factory(t) { return new (t || NwbPaginatorIntl)(); };
NwbPaginatorIntl.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: NwbPaginatorIntl, factory: NwbPaginatorIntl.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NwbPaginatorIntl, [{
        type: Injectable
    }], function () { return []; }, null); })();

/**
 *
 * Porf of Angular Mateiral's Paginator
 *
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/** The default page size if there is no page size and there are no provided page size options. */
const DEFAULT_PAGE_SIZE = 50;
/**
 * Change event object that is emitted when the user selects a
 * different page size or navigates to another page.
 */
class NwbPageEvent {
}
/**
 * Component to provide navigation between paged information. Displays the size of the current
 * page, user-selectable options to change that size, what items are being shown, and
 * navigational button to go to the previous or next page.
 */
class NwbPaginatorComponent {
    constructor(_intl, _changeDetectorRef) {
        this._intl = _intl;
        this._changeDetectorRef = _changeDetectorRef;
        this.dropDownIsActive = false;
        this._pageIndex = 0;
        this._length = 0;
        this._pageSizeOptions = [];
        /** Event emitted when the paginator changes the page size or page index. */
        this.page = new EventEmitter();
        this._intlChanges = _intl.changes.subscribe(() => this._changeDetectorRef.markForCheck());
    }
    /** The zero-based page index of the displayed list of items. Defaulted to 0. */
    get pageIndex() {
        return this._pageIndex;
    }
    set pageIndex(pageIndex) {
        this._pageIndex = pageIndex;
        this._changeDetectorRef.markForCheck();
    }
    /** The length of the total number of items that are being paginated. Defaulted to 0. */
    get length() {
        return this._length;
    }
    set length(length) {
        this._length = length;
        this._changeDetectorRef.markForCheck();
    }
    /** Number of items to display on a page. By default set to 50. */
    get pageSize() {
        return this._pageSize;
    }
    set pageSize(pageSize) {
        this._pageSize = pageSize;
        this._updateDisplayedPageSizeOptions();
    }
    /** The set of provided page size options to display to the user. */
    get pageSizeOptions() {
        return this._pageSizeOptions;
    }
    set pageSizeOptions(pageSizeOptions) {
        this._pageSizeOptions = pageSizeOptions;
        this._updateDisplayedPageSizeOptions();
    }
    ngOnInit() {
        this._initialized = true;
        this._updateDisplayedPageSizeOptions();
    }
    ngOnDestroy() {
        this._intlChanges.unsubscribe();
    }
    /** Advances to the next page if it exists. */
    nextPage() {
        if (!this.hasNextPage()) {
            return;
        }
        this.pageIndex++;
        this._emitPageEvent();
    }
    /** Move back to the previous page if it exists. */
    previousPage() {
        if (!this.hasPreviousPage()) {
            return;
        }
        this.pageIndex--;
        this._emitPageEvent();
    }
    /** Whether there is a previous page. */
    hasPreviousPage() {
        return this.pageIndex >= 1 && this.pageSize != 0;
    }
    /** Whether there is a next page. */
    hasNextPage() {
        const numberOfPages = Math.ceil(this.length / this.pageSize) - 1;
        return this.pageIndex < numberOfPages && this.pageSize != 0;
    }
    /**
     * Changes the page size so that the first item displayed on the page will still be
     * displayed using the new page size.
     *
     * For example, if the page size is 10 and on the second page (items indexed 10-19) then
     * switching so that the page size is 5 will set the third page as the current page so
     * that the 10th item will still be displayed.
     */
    changePageSize(pageSize) {
        // Current page needs to be updated to reflect the new page size. Navigate to the page
        // containing the previous page's first item.
        const startIndex = this.pageIndex * this.pageSize;
        this.pageIndex = Math.floor(startIndex / pageSize) || 0;
        this.pageSize = pageSize;
        this._emitPageEvent();
    }
    /**
     * Updates the list of page size options to display to the user. Includes making sure that
     * the page size is an option and that the list is sorted.
     */
    _updateDisplayedPageSizeOptions() {
        if (!this._initialized) {
            return;
        }
        // If no page size is provided, use the first page size option or the default page size.
        if (!this.pageSize) {
            this._pageSize = this.pageSizeOptions.length != 0 ? this.pageSizeOptions[0] : DEFAULT_PAGE_SIZE;
        }
        this._displayedPageSizeOptions = this.pageSizeOptions.slice();
        if (this._displayedPageSizeOptions.indexOf(this.pageSize) == -1) {
            this._displayedPageSizeOptions.push(this.pageSize);
        }
        // Sort the numbers using a number-specific sort function.
        this._displayedPageSizeOptions.sort((a, b) => a - b);
        this._changeDetectorRef.markForCheck();
    }
    /** Emits an event notifying that a change of the paginator's properties has been triggered. */
    _emitPageEvent() {
        this.page.next({
            pageIndex: this.pageIndex,
            pageSize: this.pageSize,
            length: this.length
        });
    }
}
NwbPaginatorComponent.ɵfac = function NwbPaginatorComponent_Factory(t) { return new (t || NwbPaginatorComponent)(ɵngcc0.ɵɵdirectiveInject(NwbPaginatorIntl), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
NwbPaginatorComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: NwbPaginatorComponent, selectors: [["nwb-paginator"]], hostAttrs: [1, "nwb-paginator"], inputs: { pageIndex: "pageIndex", length: "length", pageSize: "pageSize", pageSizeOptions: "pageSizeOptions" }, outputs: { page: "page" }, decls: 16, vars: 6, consts: [["role", "navigation", "aria-label", "pagination", 1, "pagination"], [1, "pagination-list"], ["class", "nwb-single-page-option", 4, "ngIf"], [4, "ngIf"], [1, "nwb-paginator-range-label"], [1, "button", "pagination-previous", 3, "disabled", "click"], [1, "fa", "fa-angle-left"], [1, "button", "pagination-next", 3, "disabled", "click"], [1, "fa", "fa-angle-right"], [1, "nwb-single-page-option"], [1, "dropdown", 3, "ngClass", "click"], [1, "dropdown-trigger"], ["aria-haspopup", "true", "aria-controls", "dropdown-menu", 1, "button"], [1, "icon", "is-small"], [1, "fa", "fa-sort-down"], ["id", "dropdown-menu", "role", "menu", 1, "dropdown-menu"], [1, "dropdown-content"], ["class", "dropdown-item", 3, "click", 4, "ngFor", "ngForOf"], [1, "dropdown-item", 3, "click"]], template: function NwbPaginatorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "nav", 0);
        ɵngcc0.ɵɵelementStart(1, "ul", 1);
        ɵngcc0.ɵɵelementStart(2, "li");
        ɵngcc0.ɵɵelementStart(3, "span");
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵtemplate(5, NwbPaginatorComponent_strong_5_Template, 2, 1, "strong", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(6, NwbPaginatorComponent_li_6_Template, 11, 5, "li", 3);
        ɵngcc0.ɵɵelementStart(7, "li");
        ɵngcc0.ɵɵelementStart(8, "span", 4);
        ɵngcc0.ɵɵtext(9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "li");
        ɵngcc0.ɵɵelementStart(11, "button", 5);
        ɵngcc0.ɵɵlistener("click", function NwbPaginatorComponent_Template_button_click_11_listener() { return ctx.previousPage(); });
        ɵngcc0.ɵɵelement(12, "i", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(13, "li");
        ɵngcc0.ɵɵelementStart(14, "button", 7);
        ɵngcc0.ɵɵlistener("click", function NwbPaginatorComponent_Template_button_click_14_listener() { return ctx.nextPage(); });
        ɵngcc0.ɵɵelement(15, "i", 8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate1("", ctx._intl.itemsPerPageLabel, " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx._displayedPageSizeOptions.length <= 1);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx._displayedPageSizeOptions.length > 1);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx._intl.getRangeLabel(ctx.pageIndex, ctx.pageSize, ctx.length), " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("disabled", !ctx.hasPreviousPage());
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("disabled", !ctx.hasNextPage());
    } }, directives: [ɵngcc3.NgIf, ɵngcc3.NgClass, ɵngcc3.NgForOf], encapsulation: 2, changeDetection: 0 });
NwbPaginatorComponent.ctorParameters = () => [
    { type: NwbPaginatorIntl },
    { type: ChangeDetectorRef }
];
NwbPaginatorComponent.propDecorators = {
    pageIndex: [{ type: Input }],
    length: [{ type: Input }],
    pageSize: [{ type: Input }],
    pageSizeOptions: [{ type: Input }],
    page: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NwbPaginatorComponent, [{
        type: Component,
        args: [{
                selector: 'nwb-paginator',
                template: "<nav class=\"pagination\" role=\"navigation\" aria-label=\"pagination\">\n\n  <ul class=\"pagination-list\">\n    <li>\n      <span>{{_intl.itemsPerPageLabel}}\n        <strong *ngIf=\"_displayedPageSizeOptions.length <= 1\"\n                class=\"nwb-single-page-option\">{{pageSize}}</strong>\n      </span>\n\n    </li>\n    <li *ngIf=\"_displayedPageSizeOptions.length > 1\">\n      <div class=\"dropdown\"\n           [ngClass]=\"{'is-active':dropDownIsActive}\"\n\n           (click)=\"dropDownIsActive = !dropDownIsActive\"\n      >\n        <div class=\"dropdown-trigger\">\n          <button class=\"button\" aria-haspopup=\"true\" aria-controls=\"dropdown-menu\">\n            <span>{{pageSize}}</span>\n            <span class=\"icon is-small\">\n        <i class=\"fa fa-sort-down\"></i>\n      </span>\n          </button>\n        </div>\n        <div class=\"dropdown-menu\" id=\"dropdown-menu\" role=\"menu\">\n          <div class=\"dropdown-content\">\n            <a *ngFor=\"let pageSizeOption of _displayedPageSizeOptions\"\n               (click)=\"changePageSize(pageSizeOption)\"\n               class=\"dropdown-item\">\n              {{pageSizeOption}}\n            </a>\n          </div>\n        </div>\n      </div>\n    </li>\n\n    <li>\n      <span class=\"nwb-paginator-range-label\">\n        {{_intl.getRangeLabel(pageIndex, pageSize, length)}}\n      </span>\n    </li>\n    <li>\n      <button\n        class=\"button pagination-previous\"\n        (click)=\"previousPage()\"\n        [disabled]=\"!hasPreviousPage()\">\n        <i class=\"fa fa-angle-left\"></i>\n      </button>\n    </li>\n\n    <li>\n      <button\n        class=\"button pagination-next\"\n        (click)=\"nextPage()\"\n        [disabled]=\"!hasNextPage()\">\n        <i class=\"fa fa-angle-right\"></i>\n      </button>\n    </li>\n\n  </ul>\n</nav>\n",
                host: {
                    class: 'nwb-paginator'
                },
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: NwbPaginatorIntl }, { type: ɵngcc0.ChangeDetectorRef }]; }, { page: [{
            type: Output
        }], pageIndex: [{
            type: Input
        }], length: [{
            type: Input
        }], pageSize: [{
            type: Input
        }], pageSizeOptions: [{
            type: Input
        }] }); })();

class NwbPaginatorModule {
}
NwbPaginatorModule.ɵfac = function NwbPaginatorModule_Factory(t) { return new (t || NwbPaginatorModule)(); };
NwbPaginatorModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: NwbPaginatorModule });
NwbPaginatorModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ providers: [NwbPaginatorIntl], imports: [[CommonModule, NwbCommonModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NwbPaginatorModule, { declarations: function () { return [NwbPaginatorComponent]; }, imports: function () { return [CommonModule, NwbCommonModule]; }, exports: function () { return [NwbPaginatorComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NwbPaginatorModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, NwbCommonModule],
                providers: [NwbPaginatorIntl],
                entryComponents: [],
                declarations: [NwbPaginatorComponent],
                exports: [NwbPaginatorComponent]
            }]
    }], null, null); })();

/**
 *
 * Porf of Angular Mateiral's Progress Bar
 *
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * <nwb-progress-bar> component.
 */
class NwbProgressBarComponent {
    constructor() {
        /** Color of the progress bar. */
        this.color = 'primary';
        this._value = 0;
        /**
         * Mode of the progress bar.
         *
         * Input must be one of these values: determinate, indeterminate, buffer, query, defaults to
         * 'determinate'.
         * Mirrored to mode attribute.
         */
        this.mode = 'determinate';
    }
    /** Value of the progressbar. Defaults to zero. Mirrored to aria-valuenow. */
    get value() {
        return this._value;
    }
    set value(v) {
        this._value = clamp(v || 0);
    }
    /** Gets the current transform value for the progress bar's primary indicator. */
    _primaryTransform() {
        let scale = this.value / 100;
        return { transform: `scaleX(${scale})` };
    }
}
NwbProgressBarComponent.ɵfac = function NwbProgressBarComponent_Factory(t) { return new (t || NwbProgressBarComponent)(); };
NwbProgressBarComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: NwbProgressBarComponent, selectors: [["nwb-progress-bar"]], hostAttrs: ["role", "progressbar", "aria-valuemin", "0", "aria-valuemax", "100", 1, "nwb-progress-bar"], hostVars: 10, hostBindings: function NwbProgressBarComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("aria-valuenow", ctx.value)("mode", ctx.mode);
        ɵngcc0.ɵɵclassProp("is-primary", ctx.color == "primary")("is-info", ctx.color == "info")("is-warning", ctx.color == "warning")("is-danger", ctx.color == "danger");
    } }, inputs: { color: "color", mode: "mode", value: "value" }, decls: 4, vars: 1, consts: [[1, "nwb-progress-bar-background", "nwb-progress-bar-element"], [1, "nwb-progress-bar-buffer", "nwb-progress-bar-element"], [1, "nwb-progress-bar-primary", "nwb-progress-bar-fill", "nwb-progress-bar-element", 3, "ngStyle"], [1, "nwb-progress-bar-secondary", "nwb-progress-bar-fill", "nwb-progress-bar-element"]], template: function NwbProgressBarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "div", 1);
        ɵngcc0.ɵɵelement(2, "div", 2);
        ɵngcc0.ɵɵelement(3, "div", 3);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngStyle", ctx._primaryTransform());
    } }, directives: [ɵngcc3.NgStyle], encapsulation: 2, changeDetection: 0 });
NwbProgressBarComponent.propDecorators = {
    color: [{ type: Input }],
    value: [{ type: Input }],
    mode: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NwbProgressBarComponent, [{
        type: Component,
        args: [{
                selector: 'nwb-progress-bar',
                host: {
                    role: 'progressbar',
                    'aria-valuemin': '0',
                    'aria-valuemax': '100',
                    '[attr.aria-valuenow]': 'value',
                    '[attr.mode]': 'mode',
                    '[class.is-primary]': 'color == "primary"',
                    '[class.is-info]': 'color == "info"',
                    '[class.is-warning]': 'color == "warning"',
                    '[class.is-danger]': 'color == "danger"',
                    class: 'nwb-progress-bar'
                },
                template: "<!-- The background div is named as such because it appears below the other divs and is not sized based on values. -->\n\n<div class=\"nwb-progress-bar-background nwb-progress-bar-element\"></div>\n<div class=\"nwb-progress-bar-buffer nwb-progress-bar-element\"></div>\n<div class=\"nwb-progress-bar-primary nwb-progress-bar-fill nwb-progress-bar-element\" [ngStyle]=\"_primaryTransform()\"></div>\n<div class=\"nwb-progress-bar-secondary nwb-progress-bar-fill nwb-progress-bar-element\"></div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None
            }]
    }], function () { return []; }, { color: [{
            type: Input
        }], mode: [{
            type: Input
        }], value: [{
            type: Input
        }] }); })();
/** Clamps a value to be between two numbers, by default 0 and 100. */
function clamp(v, min = 0, max = 100) {
    return Math.max(min, Math.min(max, v));
}

class NwbProgressBarModule {
}
NwbProgressBarModule.ɵfac = function NwbProgressBarModule_Factory(t) { return new (t || NwbProgressBarModule)(); };
NwbProgressBarModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: NwbProgressBarModule });
NwbProgressBarModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ providers: [], imports: [[CommonModule, NwbCommonModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NwbProgressBarModule, { declarations: function () { return [NwbProgressBarComponent]; }, imports: function () { return [CommonModule, NwbCommonModule]; }, exports: function () { return [NwbProgressBarComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NwbProgressBarModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, NwbCommonModule],
                providers: [],
                entryComponents: [],
                declarations: [NwbProgressBarComponent],
                exports: [NwbProgressBarComponent]
            }]
    }], null, null); })();

class NwbSnackbarComponent {
    constructor() {
        /** Subject for notifying the user that the dialog has finished closing. */
        this._afterClosed = new Subject();
        this.open = false;
        this.manualClose = false;
    }
    ngOnInit() {
        this.open = true;
        if (this.config.duration > 0) {
            this.timer = setTimeout(() => this.dismiss(false), this.config.duration);
        }
    }
    dismiss(manualClose) {
        this.open = false;
        this.manualClose = manualClose;
    }
    animationDone(event) {
        if (event.fromState === 'active' && event.toState === 'inactive') {
            this._afterClosed.next(this.manualClose);
            this._afterClosed.complete();
        }
    }
    /**
     * Gets an observable that is notified when the dialog is finished closing.
     */
    afterClosed() {
        return this._afterClosed.asObservable();
    }
}
NwbSnackbarComponent.ɵfac = function NwbSnackbarComponent_Factory(t) { return new (t || NwbSnackbarComponent)(); };
NwbSnackbarComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: NwbSnackbarComponent, selectors: [["nwb-snack-bar"]], hostAttrs: [1, "nwb-snack-bar"], decls: 4, vars: 8, consts: [[1, "columns"], [1, "column", "notification--message", 3, "ngClass", "innerHTML"], ["class", "column is-half", 4, "ngIf"], [1, "column", "is-half"], [3, "click"]], template: function NwbSnackbarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵlistener("@state.done", function NwbSnackbarComponent_Template_div_animation_state_done_0_listener($event) { return ctx.animationDone($event); });
        ɵngcc0.ɵɵelementStart(1, "div", 0);
        ɵngcc0.ɵɵelement(2, "div", 1);
        ɵngcc0.ɵɵtemplate(3, NwbSnackbarComponent_div_3_Template, 3, 3, "div", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMap("notification is-active " + (ctx.config.color ? ctx.config.color : "is-transparent"));
        ɵngcc0.ɵɵproperty("@state", ctx.open ? "active" : "inactive");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(6, _c19, ctx.config.action))("innerHTML", ctx.config.message, ɵngcc0.ɵɵsanitizeHtml);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.config.action);
    } }, directives: [ɵngcc3.NgClass, ɵngcc3.NgIf], encapsulation: 2, data: { animation: [
            trigger('state', [
                state('void', style({
                    bottom: '-100px'
                })),
                state('inactive', style({
                    bottom: '-100px'
                })),
                state('active', style({
                    bottom: '0px'
                })),
                transition('void => active', animate(300)),
                transition('active => inactive', animate(300))
            ])
        ] } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NwbSnackbarComponent, [{
        type: Component,
        args: [{
                selector: 'nwb-snack-bar',
                template: "<div [class]=\"'notification is-active ' + ((config.color) ? config.color : 'is-transparent')\"\n     [@state]=\"open ? 'active': 'inactive'\"\n     (@state.done)=\"animationDone($event)\"\n>\n  <div class=\"columns\">\n    <div class=\"column notification--message\" [ngClass]=\"{'is-half': config.action}\"\n         [innerHTML]=\"config.message\">\n    </div>\n    <div class=\"column is-half\" *ngIf=\"config.action\">\n      <button [class]=\"'button ' + ((config.buttonColor) ? config.buttonColor : 'is-success')\"\n              (click)=\"dismiss(true)\">{{config.action}}\n      </button>\n\n    </div>\n  </div>\n</div>\n",
                host: {
                    class: 'nwb-snack-bar'
                },
                encapsulation: ViewEncapsulation.None,
                animations: [
                    trigger('state', [
                        state('void', style({
                            bottom: '-100px'
                        })),
                        state('inactive', style({
                            bottom: '-100px'
                        })),
                        state('active', style({
                            bottom: '0px'
                        })),
                        transition('void => active', animate(300)),
                        transition('active => inactive', animate(300))
                    ])
                ]
            }]
    }], function () { return []; }, null); })();

class NwbSnackbarService {
    constructor(domService) {
        this.domService = domService;
    }
    open(config) {
        const componentRef = this.getComponentRef(config);
        return componentRef.instance;
    }
    getComponentRef(config) {
        const componentRef = this.domService.attachComponentPortal(NwbSnackbarComponent);
        componentRef.instance.config = config;
        componentRef.instance.afterClosed().subscribe(() => {
            componentRef.destroy();
        });
        return componentRef;
    }
}
NwbSnackbarService.ɵfac = function NwbSnackbarService_Factory(t) { return new (t || NwbSnackbarService)(ɵngcc0.ɵɵinject(DomService)); };
NwbSnackbarService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: NwbSnackbarService, factory: NwbSnackbarService.ɵfac });
NwbSnackbarService.ctorParameters = () => [
    { type: DomService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NwbSnackbarService, [{
        type: Injectable
    }], function () { return [{ type: DomService }]; }, null); })();

class NwbSnackbarModule {
}
NwbSnackbarModule.ɵfac = function NwbSnackbarModule_Factory(t) { return new (t || NwbSnackbarModule)(); };
NwbSnackbarModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: NwbSnackbarModule });
NwbSnackbarModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ providers: [NwbSnackbarService], imports: [[CommonModule, NwbCommonModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NwbSnackbarModule, { declarations: function () { return [NwbSnackbarComponent]; }, imports: function () { return [CommonModule, NwbCommonModule]; }, exports: function () { return [NwbSnackbarComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NwbSnackbarModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, NwbCommonModule],
                providers: [NwbSnackbarService],
                entryComponents: [NwbSnackbarComponent],
                declarations: [NwbSnackbarComponent],
                exports: [NwbSnackbarComponent]
            }]
    }], null, null); })();

/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
class AnimationCurves {
}
AnimationCurves.STANDARD_CURVE = 'cubic-bezier(0.4,0.0,0.2,1)';
/** @docs-private */
class AnimationDurations {
}
AnimationDurations.ENTERING = '225ms';
const SORT_ANIMATION_TRANSITION = AnimationDurations.ENTERING + ' ' + AnimationCurves.STANDARD_CURVE;
/** Animations used by MatSort. */
const nwbSortAnimations = {
    /** Animation that rotates the left pointer of the indicator based on the sorting direction. */
    arrowDirection: trigger('arrowDirection', [
        state('active-asc, asc', style({ transform: 'rotate(0deg)' })),
        state('active-desc, desc', style({ transform: 'rotate(-180deg)' })),
        transition('active-asc <=> active-desc', animate(SORT_ANIMATION_TRANSITION))
    ]),
    /** Animation that controls the arrow opacity. */
    arrowOpacity: trigger('arrowOpacity', [
        state('desc-to-active, asc-to-active, active', style({ opacity: 1 })),
        state('desc-to-hint, asc-to-hint, hint', style({ opacity: 0.54 })),
        state('hint-to-desc, active-to-desc, desc, hint-to-asc, active-to-asc, asc, void', style({ opacity: 0 })),
        // Transition between all states except for immediate transitions
        transition('* => asc, * => desc, * => active, * => hint, * => void', animate('0ms')),
        transition('* <=> *', animate(SORT_ANIMATION_TRANSITION))
    ]),
    /**
     * Animation for the translation of the arrow as a whole. States are separated into two
     * groups: ones with animations and others that are immediate. Immediate states are asc, desc,
     * peek, and active. The other states define a specific animation (source-to-destination)
     * and are determined as a function of their prev user-perceived state and what the next state
     * should be.
     */
    arrowPosition: trigger('arrowPosition', [
        // Hidden Above => Hint Center
        transition('* => desc-to-hint, * => desc-to-active', animate(SORT_ANIMATION_TRANSITION, keyframes([style({ transform: 'translateY(-25%)' }), style({ transform: 'translateY(0)' })]))),
        // Hint Center => Hidden Below
        transition('* => hint-to-desc, * => active-to-desc', animate(SORT_ANIMATION_TRANSITION, keyframes([style({ transform: 'translateY(0)' }), style({ transform: 'translateY(25%)' })]))),
        // Hidden Below => Hint Center
        transition('* => asc-to-hint, * => asc-to-active', animate(SORT_ANIMATION_TRANSITION, keyframes([style({ transform: 'translateY(25%)' }), style({ transform: 'translateY(0)' })]))),
        // Hint Center => Hidden Above
        transition('* => hint-to-asc, * => active-to-asc', animate(SORT_ANIMATION_TRANSITION, keyframes([style({ transform: 'translateY(0)' }), style({ transform: 'translateY(-25%)' })]))),
        state('desc-to-hint, asc-to-hint, hint, desc-to-active, asc-to-active, active', style({ transform: 'translateY(0)' })),
        state('hint-to-desc, active-to-desc, desc', style({ transform: 'translateY(-25%)' })),
        state('hint-to-asc, active-to-asc, asc', style({ transform: 'translateY(25%)' }))
    ])
};

/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/** @docs-private */
function getSortDuplicateSortableIdError(id) {
    return Error(`Cannot have two NwbSortables with the same id (${id}).`);
}
/** @docs-private */
function getSortHeaderNotContainedWithinSortError() {
    return Error(`NwbSortHeader must be placed within a parent element with the NwbSort directive.`);
}
/** @docs-private */
function getSortHeaderMissingIdError() {
    return Error(`NwbSortHeader must be provided with a unique id.`);
}
/** @docs-private */
function getSortInvalidDirectionError(direction) {
    return Error(`${direction} is not a valid sort direction ('asc' or 'desc').`);
}

/**
 *
 * Adaptation from angular's material
 *
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
class NwbSort {
    constructor() {
        /** Collection of all registered sortables that this directive manages. */
        this.sortables = new Map();
        /** Used to notify any child components listening to state changes. */
        this._stateChanges = new Subject();
        /**
         * The direction to set when an NwbSortable is initially sorted.
         * May be overriden by the NwbSortable's sort start.
         */
        this.start = 'asc';
        this._direction = '';
        /** Event emitted when the user changes either the active sort or sort direction. */
        this.sortChange = new EventEmitter();
    }
    /** The sort direction of the currently active NwbSortable. */
    get direction() {
        return this._direction;
    }
    set direction(direction) {
        if (isDevMode() && direction && direction !== 'asc' && direction !== 'desc') {
            throw getSortInvalidDirectionError(direction);
        }
        this._direction = direction;
    }
    /**
     * Register function to be used by the contained NwbSortables. Adds the NwbSortable to the
     * collection of NwbSortables.
     */
    register(sortable) {
        if (!sortable.id) {
            throw getSortHeaderMissingIdError();
        }
        if (this.sortables.has(sortable.id)) {
            throw getSortDuplicateSortableIdError(sortable.id);
        }
        this.sortables.set(sortable.id, sortable);
        if (sortable.id === this.active) {
            this.direction = sortable.start ? sortable.start : this.start;
        }
    }
    /**
     * Unregister function to be used by the contained NwbSortables. Removes the NwbSortable from the
     * collection of contained NwbSortables.
     */
    deregister(sortable) {
        this.sortables.delete(sortable.id);
    }
    /** Sets the active sort id and determines the new sort direction. */
    sort(sortable) {
        if (this.active !== sortable.id) {
            this.active = sortable.id;
            this.direction = sortable.start ? sortable.start : this.start;
        }
        else {
            this.direction = this.getNextSortDirection(sortable);
        }
        this.sortChange.emit({ active: this.active, direction: this.direction });
    }
    /** Returns the next sort direction of the active sortable, checking for potential overrides. */
    getNextSortDirection(sortable) {
        if (!sortable) {
            return '';
        }
        // Get the sort direction cycle with the potential sortable overrides.
        const sortOrder = ['asc', 'desc'];
        if ((sortable.start || this.start) === 'desc') {
            sortOrder.reverse();
        }
        // Get and return the next direction in the cycle
        let nextDirectionIndex = sortOrder.indexOf(this.direction) + 1;
        if (nextDirectionIndex >= sortOrder.length) {
            nextDirectionIndex = 0;
        }
        return sortOrder[nextDirectionIndex];
    }
    ngOnChanges() {
        this._stateChanges.next();
    }
    ngOnDestroy() {
        this._stateChanges.complete();
    }
}
NwbSort.ɵfac = function NwbSort_Factory(t) { return new (t || NwbSort)(); };
NwbSort.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: NwbSort, selectors: [["", "nwbSort", ""]], inputs: { start: ["nwbSortStart", "start"], direction: ["nwbSortDirection", "direction"], active: ["nwbSortActive", "active"] }, outputs: { sortChange: "nwbSortChange" }, exportAs: ["nwbSort"], features: [ɵngcc0.ɵɵNgOnChangesFeature] });
NwbSort.propDecorators = {
    active: [{ type: Input, args: ['nwbSortActive',] }],
    start: [{ type: Input, args: ['nwbSortStart',] }],
    direction: [{ type: Input, args: ['nwbSortDirection',] }],
    sortChange: [{ type: Output, args: ['nwbSortChange',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NwbSort, [{
        type: Directive,
        args: [{
                selector: '[nwbSort]',
                exportAs: 'nwbSort'
            }]
    }], function () { return []; }, { start: [{
            type: Input,
            args: ['nwbSortStart']
        }], sortChange: [{
            type: Output,
            args: ['nwbSortChange']
        }], direction: [{
            type: Input,
            args: ['nwbSortDirection']
        }], active: [{
            type: Input,
            args: ['nwbSortActive']
        }] }); })();

class NwbSortHeaderComponent {
    constructor(changeDetectorRef, _sort, _cdkColumnDef) {
        this._sort = _sort;
        this._cdkColumnDef = _cdkColumnDef;
        /**
         * Flag set to true when the indicator should be displayed while the sort is not active. Used to
         * provide an affordance that the header is sortable by showing on focus and hover.
         */
        this._showIndicatorHint = false;
        /**
         * Whether the view state animation should show the transition between the `from` and `to` states.
         */
        this._disableViewStateAnimation = false;
        /** The direction the arrow should be facing according to the current state. */
        this._arrowDirection = '';
        if (!_sort) {
            throw getSortHeaderNotContainedWithinSortError();
        }
        this._rerenderSubscription = merge(this._sort.sortChange, this._sort._stateChanges).subscribe(() => {
            if (this.isSorted()) {
                this._updateArrow();
            }
            // If this header was recently active and now no longer sorted, animate away the arrow.
            if (!this.isSorted() && this._viewState && this._viewState.toState === 'active') {
                this._disableViewStateAnimation = false;
                this._setAnimationTransitionState({
                    fromState: 'active',
                    toState: this._arrowDirection,
                });
            }
            changeDetectorRef.markForCheck();
        });
    }
    _updateArrow() {
        // Do not show the animation if the header was already shown in the right position.
        if (this._viewState && (this._viewState.toState === 'hint' || this._viewState.toState === 'active')) {
            this._disableViewStateAnimation = true;
        }
        // If the arrow is now sorted, animate the arrow into place. Otherwise, animate it away into
        // the direction it is facing.
        const viewState = this.isSorted()
            ? { fromState: this._arrowDirection, toState: 'active' }
            : { fromState: 'active', toState: this._arrowDirection };
        this._setAnimationTransitionState(viewState);
        this._showIndicatorHint = false;
        this._updateArrowDirection();
    }
    ngOnInit() {
        if (!this.id && this._cdkColumnDef) {
            this.id = this._cdkColumnDef.name;
        }
        this._sort.register(this);
        // Initialize the direction of the arrow and set the view state to be immediately that state.
        this._updateArrowDirection();
        this._setAnimationTransitionState({
            toState: this.isSorted() ? 'active' : this._arrowDirection,
        });
    }
    /** Whether this NwbSortHeader is currently sorted in either ascending or descending order. */
    isSorted() {
        return this._sort.active === this.id;
    }
    /** Triggers the sort on this sort header and removes the indicator hint. */
    handleClick(event) {
        this._sort.sort(this);
    }
    /**
     * Sets the "hint" state such that the arrow will be semi-transparently displayed as a hint to the
     * user showing what the active sort will become. If set to false, the arrow will fade away.
     */
    _setIndicatorHintVisible(visible) {
        this._showIndicatorHint = visible;
        if (!this.isSorted()) {
            this._updateArrowDirection();
            if (this._showIndicatorHint) {
                this._setAnimationTransitionState({
                    fromState: this._arrowDirection,
                    toState: 'hint',
                });
            }
            else {
                this._setAnimationTransitionState({
                    fromState: 'hint',
                    toState: this._arrowDirection,
                });
            }
        }
    }
    /**
     * Sets the animation transition view state for the arrow's position and opacity. If the
     * `disableViewStateAnimation` flag is set to true, the `fromState` will be ignored so that
     * no animation appears.
     */
    _setAnimationTransitionState(viewState) {
        this._viewState = viewState;
        // If the animation for arrow position state (opacity/translation) should be disabled,
        // remove the fromState so that it jumps right to the toState.
        if (this._disableViewStateAnimation) {
            this._viewState = { toState: viewState.toState };
        }
    }
    /**
     * Updates the direction the arrow should be pointing. If it is not sorted, the arrow should be
     * facing the start direction. Otherwise if it is sorted, the arrow should point in the currently
     * active sorted direction. The reason this is updated through a function is because the direction
     * should only be changed at specific times - when deactivated but the hint is displayed and when
     * the sort is active and the direction changes. Otherwise the arrow's direction should linger
     * in cases such as the sort becoming deactivated but we want to animate the arrow away while
     * preserving its direction, even though the next sort direction is actually different and should
     * only be changed once the arrow displays again (hint or activation).
     */
    _updateArrowDirection() {
        this._arrowDirection = this.isSorted() ? this._sort.direction : this.start || this._sort.start;
    }
    /** Returns the arrow position state (opacity, translation). */
    _getArrowViewState() {
        const fromState = this._viewState.fromState;
        return (fromState ? `${fromState}-to-` : '') + this._viewState.toState;
    }
    /** Returns the animation state for the arrow direction (indicator and pointers). */
    _getArrowDirectionState() {
        return `${this.isSorted() ? 'active-' : ''}${this._arrowDirection}`;
    }
    ngOnDestroy() {
        this._sort.deregister(this);
        this._rerenderSubscription.unsubscribe();
    }
}
NwbSortHeaderComponent.ɵfac = function NwbSortHeaderComponent_Factory(t) { return new (t || NwbSortHeaderComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(NwbSort, 8), ɵngcc0.ɵɵdirectiveInject(ɵngcc5.CdkColumnDef, 8)); };
NwbSortHeaderComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: NwbSortHeaderComponent, selectors: [["", "nwb-sort-header", ""]], hostBindings: function NwbSortHeaderComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function NwbSortHeaderComponent_click_HostBindingHandler($event) { return ctx.handleClick($event); });
    } }, inputs: { id: ["nwb-sort-header", "id"], start: "start" }, attrs: _c20, ngContentSelectors: _c2, decls: 4, vars: 5, consts: [[1, "nwb-sort-header-container", 3, "mouseenter", "mouseleave"], [1, "nwb-sort-header-arrow"], [1, "fas", "fa-angle-up"]], template: function NwbSortHeaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵlistener("mouseenter", function NwbSortHeaderComponent_Template_div_mouseenter_0_listener() { return ctx._setIndicatorHintVisible(true); })("mouseleave", function NwbSortHeaderComponent_Template_div_mouseleave_0_listener() { return ctx._setIndicatorHintVisible(false); });
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵelementStart(2, "span", 1);
        ɵngcc0.ɵɵlistener("@arrowPosition.start", function NwbSortHeaderComponent_Template_span_animation_arrowPosition_start_2_listener() { return ctx._disableViewStateAnimation = true; })("@arrowPosition.done", function NwbSortHeaderComponent_Template_span_animation_arrowPosition_done_2_listener() { return ctx._disableViewStateAnimation = false; });
        ɵngcc0.ɵɵelement(3, "i", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵclassProp("nwb-sort-header-sorted", ctx.isSorted());
        ɵngcc0.ɵɵproperty("@arrowOpacity", ctx._getArrowViewState())("@arrowPosition", ctx._getArrowViewState());
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("@arrowDirection", ctx._getArrowDirectionState());
    } }, encapsulation: 2, data: { animation: [nwbSortAnimations.arrowDirection, nwbSortAnimations.arrowOpacity, nwbSortAnimations.arrowPosition] } });
NwbSortHeaderComponent.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: NwbSort, decorators: [{ type: Optional }] },
    { type: CdkColumnDef, decorators: [{ type: Optional }] }
];
NwbSortHeaderComponent.propDecorators = {
    id: [{ type: Input, args: ['nwb-sort-header',] }],
    start: [{ type: Input }],
    handleClick: [{ type: HostListener, args: ['click', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NwbSortHeaderComponent, [{
        type: Component,
        args: [{
                selector: '[nwb-sort-header]',
                template: "<div class=\"nwb-sort-header-container\"\n     (mouseenter)=\"_setIndicatorHintVisible(true)\"\n     (mouseleave)=\"_setIndicatorHintVisible(false)\"\n>\n  <ng-content></ng-content>\n  <span class=\"nwb-sort-header-arrow\" [class.nwb-sort-header-sorted]=\"isSorted()\"\n        [@arrowOpacity]=\"_getArrowViewState()\"\n        [@arrowPosition]=\"_getArrowViewState()\"\n        (@arrowPosition.start)=\"_disableViewStateAnimation = true\"\n        (@arrowPosition.done)=\"_disableViewStateAnimation = false\"\n  >\n     <i class=\"fas fa-angle-up\" [@arrowDirection]=\"_getArrowDirectionState()\"></i>\n  </span>\n</div>\n",
                animations: [nwbSortAnimations.arrowDirection, nwbSortAnimations.arrowOpacity, nwbSortAnimations.arrowPosition]
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: NwbSort, decorators: [{
                type: Optional
            }] }, { type: ɵngcc5.CdkColumnDef, decorators: [{
                type: Optional
            }] }]; }, { id: [{
            type: Input,
            args: ['nwb-sort-header']
        }], 
    /** Triggers the sort on this sort header and removes the indicator hint. */
    handleClick: [{
            type: HostListener,
            args: ['click', ['$event']]
        }], start: [{
            type: Input
        }] }); })();

class NwbSortModule {
}
NwbSortModule.ɵfac = function NwbSortModule_Factory(t) { return new (t || NwbSortModule)(); };
NwbSortModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: NwbSortModule });
NwbSortModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ providers: [], imports: [[CommonModule, NwbCommonModule, CdkTableModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NwbSortModule, { declarations: function () { return [NwbSort, NwbSortHeaderComponent]; }, imports: function () { return [CommonModule, NwbCommonModule, CdkTableModule]; }, exports: function () { return [NwbSort, NwbSortHeaderComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NwbSortModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, NwbCommonModule, CdkTableModule],
                providers: [],
                entryComponents: [],
                declarations: [NwbSort, NwbSortHeaderComponent],
                exports: [NwbSort, NwbSortHeaderComponent]
            }]
    }], null, null); })();

class NwbSwitchComponent {
    constructor() {
        this.disabled = false;
        this.checked = true;
        this.currentValue = null;
        this._id = null;
    }
    writeValue(obj) {
        this._setValue(obj);
    }
    registerOnChange(fn) {
        this._onChanged = fn;
    }
    registerOnTouched(fn) {
        this._onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    change() {
        this._setValue(this.checked);
    }
    _setValue(value) {
        if (typeof value !== 'boolean') {
            return;
        }
        const init = this.currentValue === null;
        this.currentValue = value;
        if (this.checked !== this.currentValue) {
            this.checked = this.currentValue === true;
        }
        if (init) {
            return;
        }
        if (typeof this._onChanged === 'function') {
            this._onChanged(this.currentValue);
        }
    }
    getId() {
        if (!this._id) {
            this._id = 'search-' + Math.random().toString().replace('.', '-');
        }
        return this._id;
    }
}
NwbSwitchComponent.ɵfac = function NwbSwitchComponent_Factory(t) { return new (t || NwbSwitchComponent)(); };
NwbSwitchComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: NwbSwitchComponent, selectors: [["nwb-switch"]], hostAttrs: [1, "nwb-switch"], inputs: { disabled: "disabled", checked: "checked", extraClasses: "extraClasses" }, features: [ɵngcc0.ɵɵProvidersFeature([{ provide: NG_VALUE_ACCESSOR, useExisting: NwbSwitchComponent, multi: true }])], ngContentSelectors: _c2, decls: 4, vars: 7, consts: [[1, "field"], ["type", "checkbox", 3, "id", "ngModel", "ngModelChange", "change"], [3, "for"]], template: function NwbSwitchComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "input", 1);
        ɵngcc0.ɵɵlistener("ngModelChange", function NwbSwitchComponent_Template_input_ngModelChange_1_listener($event) { return ctx.checked = $event; })("change", function NwbSwitchComponent_Template_input_change_1_listener() { return ctx.change(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "label", 2);
        ɵngcc0.ɵɵprojection(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMapInterpolate1("switch ", ctx.extraClasses, "");
        ɵngcc0.ɵɵproperty("id", ctx.getId())("ngModel", ctx.checked);
        ɵngcc0.ɵɵattribute("disabled", ctx.disabled ? "disabled" : null);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("for", ctx.getId());
    } }, directives: [ɵngcc4.CheckboxControlValueAccessor, ɵngcc4.NgControlStatus, ɵngcc4.NgModel], styles: [".switch[type=checkbox]{max-width:0}"], encapsulation: 2 });
NwbSwitchComponent.propDecorators = {
    extraClasses: [{ type: Input }],
    disabled: [{ type: Input }],
    checked: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NwbSwitchComponent, [{
        type: Component,
        args: [{
                selector: 'nwb-switch',
                template: "<div class=\"field\">\n  <input [id]=\"getId()\" type=\"checkbox\" class=\"switch {{extraClasses}}\"\n         [(ngModel)]=\"checked\"\n         [attr.disabled]=\"disabled ? 'disabled' : null\"\n         (change)=\"change()\"\n  >\n  <label [for]=\"getId()\">\n    <ng-content>\n    </ng-content>\n  </label>\n</div>\n",
                host: {
                    class: 'nwb-switch'
                },
                encapsulation: ViewEncapsulation.None,
                providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: NwbSwitchComponent, multi: true }],
                styles: [".switch[type=checkbox]{max-width:0}"]
            }]
    }], function () { return []; }, { disabled: [{
            type: Input
        }], checked: [{
            type: Input
        }], extraClasses: [{
            type: Input
        }] }); })();

class NwbSwitchModule {
}
NwbSwitchModule.ɵfac = function NwbSwitchModule_Factory(t) { return new (t || NwbSwitchModule)(); };
NwbSwitchModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: NwbSwitchModule });
NwbSwitchModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ providers: [], imports: [[CommonModule, FormsModule, NwbCommonModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NwbSwitchModule, { declarations: function () { return [NwbSwitchComponent]; }, imports: function () { return [CommonModule, FormsModule, NwbCommonModule]; }, exports: function () { return [NwbSwitchComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NwbSwitchModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, FormsModule, NwbCommonModule],
                providers: [],
                entryComponents: [],
                declarations: [NwbSwitchComponent],
                exports: [NwbSwitchComponent]
            }]
    }], null, null); })();

class NwbTabComponent {
    setSelected(isSelected) {
        this.isSelected = isSelected;
    }
}
NwbTabComponent.ɵfac = function NwbTabComponent_Factory(t) { return new (t || NwbTabComponent)(); };
NwbTabComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: NwbTabComponent, selectors: [["nwb-tab"]], inputs: { label: "label", icon: "icon" }, ngContentSelectors: _c2, decls: 1, vars: 1, consts: [[4, "ngIf"]], template: function NwbTabComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, NwbTabComponent_ng_content_0_Template, 1, 0, "ng-content", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.isSelected);
    } }, directives: [ɵngcc3.NgIf], encapsulation: 2 });
NwbTabComponent.propDecorators = {
    label: [{ type: Input }],
    icon: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NwbTabComponent, [{
        type: Component,
        args: [{
                selector: 'nwb-tab',
                template: `
    <ng-content *ngIf="isSelected">
    </ng-content>
  `
            }]
    }], null, { label: [{
            type: Input
        }], icon: [{
            type: Input
        }] }); })();

class NwbTabsComponent {
    constructor() {
        /** IE: [(selectedIndex)]="active" (optional, will equal first tab by default) **/
        this._selectedIndex = 0;
        this.selectedIndexChange = new EventEmitter();
    }
    set selectedIndex(selectedIndex) {
        this.select(selectedIndex);
    }
    get selectedIndex() {
        return this._selectedIndex;
    }
    ngOnInit() {
        if (this.rounded) {
            this.toggle = true;
        }
    }
    select(index) {
        if (this._selectedIndex === index) {
            return;
        }
        this._selectedIndex = index;
        if (this.tabList) {
            this.tabList.forEach((tab) => {
                tab.setSelected(tab.index === this.selectedIndex);
            });
            this.selectedIndexChange.emit(this.selectedIndex);
        }
    }
    ngAfterContentInit() {
        this.tabList.forEach((tab, index) => {
            tab.index = index;
            tab.setSelected(tab.index === this.selectedIndex);
        });
    }
}
NwbTabsComponent.ɵfac = function NwbTabsComponent_Factory(t) { return new (t || NwbTabsComponent)(); };
NwbTabsComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: NwbTabsComponent, selectors: [["nwb-tabs"]], contentQueries: function NwbTabsComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, NwbTabComponent, 0);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.tabList = _t);
    } }, inputs: { selectedIndex: "selectedIndex", toggle: "toggle", box: "box", alignment: "alignment", size: "size", rounded: "rounded", fullwidth: "fullwidth" }, outputs: { selectedIndexChange: "selectedIndexChange" }, ngContentSelectors: _c2, decls: 4, vars: 9, consts: [[3, "ngClass", "click", 4, "ngFor", "ngForOf"], [3, "ngClass", "click"], ["class", "icon", 4, "ngIf"], [1, "icon"]], template: function NwbTabsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵelementStart(1, "ul");
        ɵngcc0.ɵɵtemplate(2, NwbTabsComponent_li_2_Template, 5, 5, "li", 0);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵprojection(3);
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMapInterpolate6("tabs\n    ", ctx.alignment && "is-" + ctx.alignment, "\n    ", ctx.size && "is-" + ctx.size, "\n    ", ctx.box && "is-boxed", "\n    ", ctx.toggle && "is-toggle", "\n    ", ctx.rounded && "is-toggle-rounded", "\n    ", ctx.fullwidth && "is-fullwidth", "");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.tabList);
    } }, directives: [ɵngcc3.NgForOf, ɵngcc3.NgClass, ɵngcc3.NgIf], encapsulation: 2 });
NwbTabsComponent.ctorParameters = () => [];
NwbTabsComponent.propDecorators = {
    box: [{ type: Input }],
    alignment: [{ type: Input }],
    size: [{ type: Input }],
    toggle: [{ type: Input }],
    rounded: [{ type: Input }],
    fullwidth: [{ type: Input }],
    selectedIndex: [{ type: Input }],
    selectedIndexChange: [{ type: Output }],
    tabList: [{ type: ContentChildren, args: [NwbTabComponent,] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NwbTabsComponent, [{
        type: Component,
        args: [{
                selector: 'nwb-tabs',
                template: `
    <div class="tabs
    {{alignment&&'is-'+alignment}}
    {{size&&'is-'+size}}
    {{box&&'is-boxed'}}
    {{toggle&&'is-toggle'}}
    {{rounded&&'is-toggle-rounded'}}
    {{fullwidth&&'is-fullwidth'}}">
      <ul>
        <li *ngFor="let tab of tabList"
            [ngClass]="{'is-active':selectedIndex===tab.index}"
            (click)="select(tab.index)">
          <a>
          <span *ngIf="tab.icon" class="icon">
            <i class="{{tab.icon}}"></i>
          </span>
            <span>{{tab.label}}</span>
          </a>
        </li>
      </ul>
    </div>
    <ng-content></ng-content>
  `
            }]
    }], function () { return []; }, { selectedIndexChange: [{
            type: Output
        }], selectedIndex: [{
            type: Input
        }], toggle: [{
            type: Input
        }], box: [{
            type: Input
        }], alignment: [{
            type: Input
        }], size: [{
            type: Input
        }], rounded: [{
            type: Input
        }], fullwidth: [{
            type: Input
        }], tabList: [{
            type: ContentChildren,
            args: [NwbTabComponent]
        }] }); })();

class NwbTabsModule {
}
NwbTabsModule.ɵfac = function NwbTabsModule_Factory(t) { return new (t || NwbTabsModule)(); };
NwbTabsModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: NwbTabsModule });
NwbTabsModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ providers: [], imports: [[CommonModule, NwbCommonModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NwbTabsModule, { declarations: function () { return [NwbTabsComponent, NwbTabComponent]; }, imports: function () { return [CommonModule, NwbCommonModule]; }, exports: function () { return [NwbTabsComponent, NwbTabComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NwbTabsModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, NwbCommonModule],
                providers: [],
                entryComponents: [],
                declarations: [NwbTabsComponent, NwbTabComponent],
                exports: [NwbTabsComponent, NwbTabComponent]
            }]
    }], null, null); })();

class NwbDatePickerIntl {
    constructor() {
        this.closeLabel = 'Close';
        this.clearLabel = 'Clear';
        this.todayLabel = 'Today';
        this.nowLabel = 'Now';
        this.labelFrom = '';
        this.labelTo = '';
    }
}
NwbDatePickerIntl.ɵfac = function NwbDatePickerIntl_Factory(t) { return new (t || NwbDatePickerIntl)(); };
NwbDatePickerIntl.ɵprov = ɵɵdefineInjectable({ factory: function NwbDatePickerIntl_Factory() { return new NwbDatePickerIntl(); }, token: NwbDatePickerIntl, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NwbDatePickerIntl, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return []; }, null); })();

/** InjectionToken for datepicker that can be used to override default locale code. */
const NWB_DATE_LOCALE = new InjectionToken('NWB_DATE_LOCALE', {
    providedIn: 'root',
    factory: NWB_DATE_LOCALE_FACTORY
});
/** @docs-private */
function NWB_DATE_LOCALE_FACTORY() {
    return inject(LOCALE_ID);
}
class NwbDatePickerFormat {
    constructor(locale) {
        this.dateFormat = 'MM/DD/YYYY';
        this.timeFormat = 'HH:mm';
        this.lang = locale && locale.match('-') ? locale.split('-')[1].toLowerCase() : 'en';
    }
}
NwbDatePickerFormat.ɵfac = function NwbDatePickerFormat_Factory(t) { return new (t || NwbDatePickerFormat)(ɵngcc0.ɵɵinject(NWB_DATE_LOCALE)); };
NwbDatePickerFormat.ɵprov = ɵɵdefineInjectable({ factory: function NwbDatePickerFormat_Factory() { return new NwbDatePickerFormat(ɵɵinject(NWB_DATE_LOCALE)); }, token: NwbDatePickerFormat, providedIn: "root" });
NwbDatePickerFormat.ctorParameters = () => [
    { type: String, decorators: [{ type: Inject, args: [NWB_DATE_LOCALE,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NwbDatePickerFormat, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: String, decorators: [{
                type: Inject,
                args: [NWB_DATE_LOCALE]
            }] }]; }, null); })();

class NwbDatePickerDefaultSettings {
    constructor() {
        this.color = 'primary';
        this.allowSameDayRange = true;
        this.displayMode = 'default';
        this.showHeader = true;
        this.headerPosition = 'top';
        this.showFooter = true;
        this.showButtons = true;
        this.showTodayButton = true;
        this.showClearButton = true;
        this.enableMonthSwitch = true;
        this.enableYearSwitch = true;
        this.weekStart = 0;
        this.minuteSteps = 1;
        this.closeOnOverlayClick = true;
        this.closeOnSelect = true;
        this.toggleOnInputClick = true;
    }
}
NwbDatePickerDefaultSettings.ɵfac = function NwbDatePickerDefaultSettings_Factory(t) { return new (t || NwbDatePickerDefaultSettings)(); };
NwbDatePickerDefaultSettings.ɵprov = ɵɵdefineInjectable({ factory: function NwbDatePickerDefaultSettings_Factory() { return new NwbDatePickerDefaultSettings(); }, token: NwbDatePickerDefaultSettings, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NwbDatePickerDefaultSettings, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return []; }, null); })();

class NwbDatePickerComponent {
    constructor(datePickerIntl, datePickerFormat, datePrickerSettings, ngZone, elementRef) {
        this.datePickerIntl = datePickerIntl;
        this.datePickerFormat = datePickerFormat;
        this.datePrickerSettings = datePrickerSettings;
        this.ngZone = ngZone;
        this.elementRef = elementRef;
        this.options = {};
        this.change = new EventEmitter();
        this.clear = new EventEmitter();
        this.bulmaCalendar = null;
        this.datepickerInputStart = null;
        this.datepickerInputEnd = null;
        this.destroy = new Subject();
        this.initalized = false;
        this.isRange = false;
    }
    /**
     * Register an input with this datepicker.
     *  input The datepicker input to register with this datepicker.
     *  inputType
     */
    _registerInput(input, inputType) {
        let datepickerInput = null;
        switch (inputType) {
            case 'startDate':
                if (this.datepickerInputStart) {
                    throw Error('A NwbDatePickerComponent can only be associated with a single input of type: ' + inputType);
                }
                this.datepickerInputStart = input;
                datepickerInput = this.datepickerInputStart;
                break;
            case 'endDate':
                if (this.datepickerInputEnd) {
                    throw Error('A NwbDatePickerComponent can only be associated with a single input of type: ' + inputType);
                }
                this.datepickerInputEnd = input;
                datepickerInput = this.datepickerInputEnd;
                break;
            default:
                throw Error('Invalid inputType:' + inputType);
        }
        datepickerInput._valueChange.pipe(takeUntil(this.destroy)).subscribe(() => {
            if (!this.initalized) {
                return;
            }
            this.resetCalendar();
        });
    }
    /**
     * Since there is no way to change date dynamically, we're gonna destroy the calender and reinitialize it
     */
    resetCalendar() {
        if (this.bulmaCalendar) {
            this.bulmaCalendar = null;
            const calendarWrapperEl = this.elementRef.nativeElement.querySelector('.datetimepicker-dummy');
            if (calendarWrapperEl) {
                this.ngWiziDatePicker.nativeElement.setAttribute('type', 'text');
                const rootCalendarNode = calendarWrapperEl.parentElement;
                this.elementRef.nativeElement.insertBefore(this.ngWiziDatePicker.nativeElement, rootCalendarNode);
                rootCalendarNode.remove();
                this.initalized = false;
                this.initialize();
            }
        }
        else {
            this.initialize();
        }
    }
    setValue(startDate, endDate) {
        let somethingHasChanged = false;
        if (this.datepickerInputStart.getDate().getTime() !== startDate.getTime()) {
            somethingHasChanged = true;
        }
        if (endDate && this.datepickerInputEnd.getDate().getTime() !== endDate.getTime()) {
            somethingHasChanged = true;
        }
        if (!somethingHasChanged) {
            return;
        }
        this.change.emit({
            startDate: new Date(startDate.toISOString()),
            endDate: this.isRange ? new Date(endDate.toISOString()) : new Date(startDate.toISOString()),
        });
    }
    /**
     * Ugly hack to make timepicker change without having to press validate button since
     * the behavior between the timepicker and datepicker differs
     */
    _initEvents() {
        const elements = [];
        const timepickerStartEl = this.elementRef.nativeElement.querySelector('.timepicker-start');
        if (timepickerStartEl) {
            elements.push(timepickerStartEl.querySelector('.timepicker-hours .timepicker-next'));
            elements.push(timepickerStartEl.querySelector('.timepicker-hours .timepicker-previous'));
            elements.push(timepickerStartEl.querySelector('.timepicker-minutes .timepicker-next'));
            elements.push(timepickerStartEl.querySelector('.timepicker-minutes .timepicker-previous'));
        }
        const timepickerEndEl = this.elementRef.nativeElement.querySelector('.timepicker-end');
        if (timepickerEndEl) {
            elements.push(timepickerEndEl.querySelector('.timepicker-hours .timepicker-next'));
            elements.push(timepickerEndEl.querySelector('.timepicker-hours .timepicker-previous'));
            elements.push(timepickerEndEl.querySelector('.timepicker-minutes .timepicker-next'));
            elements.push(timepickerEndEl.querySelector('.timepicker-minutes .timepicker-previous'));
        }
        elements.forEach((element) => {
            fromEvent(element, 'click')
                .pipe(takeUntil(this.destroy))
                .subscribe(() => {
                this.bulmaCalendar.save();
                this.bulmaCalendar.emit('select', this.bulmaCalendar);
                setTimeout(() => {
                    this.bulmaCalendar.refresh();
                }, 100);
            });
        });
    }
    getDateAndTimePart(input) {
        const date = input.getDate();
        const time = input.getDate();
        date.setHours(0, 0, 0, 0);
        return { date, time };
    }
    initialize() {
        if (this.initalized) {
            console.log('Already initialized');
            return;
        }
        this.initalized = true;
        const privateOptions = {
            type: 'date',
            isRange: false,
            startDate: null,
            start: null,
            endDate: null,
            end: null,
        };
        if (this.datepickerInputStart && this.datepickerInputStart.value) {
            const _start = this.getDateAndTimePart(this.datepickerInputStart);
            privateOptions.startDate = _start.date;
            privateOptions.start = _start.time;
        }
        if (this.datepickerInputEnd) {
            privateOptions.isRange = true;
            if (this.datepickerInputEnd.value) {
                const _end = this.getDateAndTimePart(this.datepickerInputEnd);
                privateOptions.endDate = _end.date;
                privateOptions.end = _end.time;
            }
            if (privateOptions.endDate < privateOptions.startDate) {
                console.log('Error the end date cannot be before the start date');
            }
        }
        const elementType = this.datepickerInputStart.dateType;
        switch (elementType) {
            case 'datetime':
                privateOptions.type = 'datetime';
                this.options.showFooter = true;
                this.options.showButtons = true;
                this.ngWiziDatePicker.nativeElement.type = 'text';
                break;
            case 'date':
                privateOptions.type = 'date';
                this.ngWiziDatePicker.nativeElement.type = 'date';
                break;
        }
        const options = Object.assign(privateOptions, this.datePickerFormat, this.datePickerIntl, this.datePrickerSettings, this.options);
        if (!options.closeLabel) {
            // Change cancel to close
            options.closeLabel = '';
        }
        options['cancelLabel'] = options.closeLabel;
        this.isRange = options.isRange;
        this.bulmaCalendar = new bulmaCalendar(this.ngWiziDatePicker.nativeElement, options);
        // Ready events doesn't work
        setTimeout(() => {
            this._initEvents();
            this.bulmaCalendar.refresh();
        }, 500);
        this.bulmaCalendar.on('clear', () => {
            this.ngZone.run(() => {
                this.clear.next(true);
            });
        });
        this.bulmaCalendar.on('select', (data) => {
            this.ngZone.run(() => {
                const datePicker = data.data.datePicker;
                const timePicker = data.data.timePicker;
                let startDate;
                let endDate;
                if (!datePicker.start) {
                    return;
                }
                // Clone the date
                startDate = new Date(datePicker.start.toISOString());
                if (timePicker) {
                    startDate.setHours(timePicker.start.getHours(), timePicker.start.getMinutes(), 0, 0);
                }
                if (this.isRange) {
                    if (!datePicker.end) {
                        return;
                    }
                    // Clone the date
                    endDate = new Date(datePicker.end.toISOString());
                    if (timePicker) {
                        endDate.setHours(timePicker.end.getHours(), timePicker.end.getMinutes(), 0, 0);
                    }
                }
                this.setValue(startDate, endDate);
            });
        });
    }
    ngAfterViewInit() {
        this.initialize();
    }
    ngOnDestroy() {
        this.destroy.next();
        this.destroy.complete();
    }
}
NwbDatePickerComponent.ɵfac = function NwbDatePickerComponent_Factory(t) { return new (t || NwbDatePickerComponent)(ɵngcc0.ɵɵdirectiveInject(NwbDatePickerIntl), ɵngcc0.ɵɵdirectiveInject(NwbDatePickerFormat), ɵngcc0.ɵɵdirectiveInject(NwbDatePickerDefaultSettings), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
NwbDatePickerComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: NwbDatePickerComponent, selectors: [["nwb-date-picker"]], viewQuery: function NwbDatePickerComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c21, 3);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.ngWiziDatePicker = _t.first);
    } }, inputs: { options: "options" }, outputs: { change: "change", clear: "clear" }, ngContentSelectors: _c2, decls: 4, vars: 0, consts: [[2, "display", "none"], ["type", "date", 1, "ngWiziDatePicker"], ["ngWiziDatePicker", ""]], template: function NwbDatePickerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(2, "input", 1, 2);
    } }, styles: [".datetimepicker-footer-validate[_ngcontent-%COMP%]{display:none}"], changeDetection: 0 });
NwbDatePickerComponent.ctorParameters = () => [
    { type: NwbDatePickerIntl },
    { type: NwbDatePickerFormat },
    { type: NwbDatePickerDefaultSettings },
    { type: NgZone },
    { type: ElementRef }
];
NwbDatePickerComponent.propDecorators = {
    options: [{ type: Input }],
    change: [{ type: Output }],
    clear: [{ type: Output }],
    ngWiziDatePicker: [{ type: ViewChild, args: ['ngWiziDatePicker', { static: true },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NwbDatePickerComponent, [{
        type: Component,
        args: [{
                selector: 'nwb-date-picker',
                template: "<div style=\"display:none;\">\n  <ng-content></ng-content>\n</div>\n\n<input class=\"ngWiziDatePicker\" #ngWiziDatePicker type=\"date\" />\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [".datetimepicker-footer-validate{display:none}"]
            }]
    }], function () { return [{ type: NwbDatePickerIntl }, { type: NwbDatePickerFormat }, { type: NwbDatePickerDefaultSettings }, { type: ɵngcc0.NgZone }, { type: ɵngcc0.ElementRef }]; }, { options: [{
            type: Input
        }], change: [{
            type: Output
        }], clear: [{
            type: Output
        }], ngWiziDatePicker: [{
            type: ViewChild,
            args: ['ngWiziDatePicker', { static: true }]
        }] }); })();

/** Directive used to connect an input to a MatDatepicker. */
class NwbDatePickerInputBaseDirective {
    constructor(elementRef) {
        this.elementRef = elementRef;
        this._datepickerSubscription = Subscription.EMPTY;
        /** Emits when the value changes (either due to user input or programmatic change). */
        this._valueChange = new EventEmitter();
        this.nwbDateType = 'date';
    }
    /** The value of the input. */
    get value() {
        return this._value;
    }
    set value(value) {
        const oldDate = this.value;
        this._value = value;
        this.elementRef.nativeElement.value = value;
        if (!!oldDate && oldDate !== value) {
            this._valueChange.emit(value);
        }
    }
    set dateType(type) {
        this.nwbDateType = type;
    }
    get dateType() {
        return this.nwbDateType;
    }
    registerInput(datePickerComponent, inputType) {
        if (!(datePickerComponent instanceof NwbDatePickerComponent)) {
            return;
        }
        const type = this.elementRef.nativeElement.getAttribute('type');
        if (type !== 'text') {
            console.warn(`nwb-date-picker deprecated warning. The use of an input type "date" or "datetime-local" is now deprecated due to the lack of timezone. Use an input type "text" and set the attribute "nwbDateType" instead.`);
            this.dateType = type === 'date' ? 'date' : 'datetime';
            this.elementRef.nativeElement.setAttribute('type', 'text');
        }
        this._datepicker = datePickerComponent;
        this._datepicker._registerInput(this, inputType);
        this._datepickerSubscription.unsubscribe();
        this._datepickerSubscription = this._datepicker.change.subscribe((value) => {
            let dateStr;
            if (inputType === 'startDate') {
                dateStr = value.startDate.toISOString();
            }
            else {
                dateStr = value.endDate.toISOString();
            }
            this.elementRef.nativeElement.value = dateStr;
            this._value = dateStr;
            if (this._onChanged) {
                this._onChanged(dateStr);
            }
        });
    }
    getDate() {
        if (!this._value) {
            return new Date();
        }
        const date = new Date(this._value);
        const finalDate = new Date();
        finalDate.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
        finalDate.setHours(date.getHours(), date.getMinutes(), 0, 0);
        if (this.dateType === 'date') {
            finalDate.setHours(0, 0, 0, 0);
        }
        return finalDate;
    }
    writeValue(value) {
        this.value = value;
    }
    registerOnChange(fn) {
        this._onChanged = fn;
    }
    registerOnTouched(fn) {
        this._onTouched = fn;
    }
    ngOnDestroy() {
        this._datepickerSubscription.unsubscribe();
    }
}
NwbDatePickerInputBaseDirective.ɵfac = function NwbDatePickerInputBaseDirective_Factory(t) { return new (t || NwbDatePickerInputBaseDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
NwbDatePickerInputBaseDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: NwbDatePickerInputBaseDirective, inputs: { nwbDateType: "nwbDateType", value: "value" } });
NwbDatePickerInputBaseDirective.ctorParameters = () => [
    { type: ElementRef }
];
NwbDatePickerInputBaseDirective.propDecorators = {
    value: [{ type: Input }],
    nwbDateType: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NwbDatePickerInputBaseDirective, [{
        type: Directive
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { nwbDateType: [{
            type: Input
        }], value: [{
            type: Input
        }] }); })();

/** Directive used to connect an input to a MatDatepicker. */
class NwbDatePickerInputEndDirective extends NwbDatePickerInputBaseDirective {
    constructor(elementRef) {
        super(elementRef);
        this.elementRef = elementRef;
    }
    /** The datepicker that this input is associated with. */
    set nwbDatepickerEnd(datePickerComponent) {
        this.registerInput(datePickerComponent, 'endDate');
    }
}
NwbDatePickerInputEndDirective.ɵfac = function NwbDatePickerInputEndDirective_Factory(t) { return new (t || NwbDatePickerInputEndDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
NwbDatePickerInputEndDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: NwbDatePickerInputEndDirective, selectors: [["input", "nwbDatepickerEnd", ""]], inputs: { nwbDatepickerEnd: "nwbDatepickerEnd", nwbDateType: "nwbDateType" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: NwbDatePickerInputEndDirective,
                multi: true
            },
        ]), ɵngcc0.ɵɵInheritDefinitionFeature] });
NwbDatePickerInputEndDirective.ctorParameters = () => [
    { type: ElementRef }
];
NwbDatePickerInputEndDirective.propDecorators = {
    nwbDatepickerEnd: [{ type: Input }],
    nwbDateType: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NwbDatePickerInputEndDirective, [{
        type: Directive,
        args: [{
                selector: 'input[nwbDatepickerEnd]',
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: NwbDatePickerInputEndDirective,
                        multi: true
                    },
                ]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { nwbDatepickerEnd: [{
            type: Input
        }], nwbDateType: [{
            type: Input
        }] }); })();

/** Directive used to connect an input to a MatDatepicker. */
class NwbDatePickerInputStartDirective extends NwbDatePickerInputBaseDirective {
    constructor(elementRef) {
        super(elementRef);
        this.elementRef = elementRef;
    }
    /** The datepicker that this input is associated with. */
    set nwbDatepickerStart(datePickerComponent) {
        this.registerInput(datePickerComponent, 'startDate');
    }
}
NwbDatePickerInputStartDirective.ɵfac = function NwbDatePickerInputStartDirective_Factory(t) { return new (t || NwbDatePickerInputStartDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
NwbDatePickerInputStartDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: NwbDatePickerInputStartDirective, selectors: [["input", "nwbDatepickerStart", ""]], inputs: { nwbDatepickerStart: "nwbDatepickerStart" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: NwbDatePickerInputStartDirective,
                multi: true
            }
        ]), ɵngcc0.ɵɵInheritDefinitionFeature] });
NwbDatePickerInputStartDirective.ctorParameters = () => [
    { type: ElementRef }
];
NwbDatePickerInputStartDirective.propDecorators = {
    nwbDatepickerStart: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NwbDatePickerInputStartDirective, [{
        type: Directive,
        args: [{
                selector: 'input[nwbDatepickerStart]',
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: NwbDatePickerInputStartDirective,
                        multi: true
                    }
                ]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { nwbDatepickerStart: [{
            type: Input
        }] }); })();

/** Directive used to connect an input to a MatDatepicker. */
class NwbDatePickerInputDateTypeDirective extends NwbDatePickerInputBaseDirective {
    constructor(elementRef) {
        super(elementRef);
        this.elementRef = elementRef;
    }
}
NwbDatePickerInputDateTypeDirective.ɵfac = function NwbDatePickerInputDateTypeDirective_Factory(t) { return new (t || NwbDatePickerInputDateTypeDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
NwbDatePickerInputDateTypeDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: NwbDatePickerInputDateTypeDirective, selectors: [["input", "nwbDateType", ""]], inputs: { nwbDateType: "nwbDateType" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
NwbDatePickerInputDateTypeDirective.ctorParameters = () => [
    { type: ElementRef }
];
NwbDatePickerInputDateTypeDirective.propDecorators = {
    nwbDateType: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NwbDatePickerInputDateTypeDirective, [{
        type: Directive,
        args: [{
                selector: 'input[nwbDateType]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { nwbDateType: [{
            type: Input
        }] }); })();

class NwbDatePickerModule {
}
NwbDatePickerModule.ɵfac = function NwbDatePickerModule_Factory(t) { return new (t || NwbDatePickerModule)(); };
NwbDatePickerModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: NwbDatePickerModule });
NwbDatePickerModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ providers: [], imports: [[CommonModule, NwbCommonModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NwbDatePickerModule, { declarations: function () { return [NwbDatePickerComponent, NwbDatePickerInputStartDirective, NwbDatePickerInputEndDirective, NwbDatePickerInputDateTypeDirective]; }, imports: function () { return [CommonModule, NwbCommonModule]; }, exports: function () { return [NwbDatePickerComponent, NwbDatePickerInputStartDirective, NwbDatePickerInputEndDirective, NwbDatePickerInputDateTypeDirective]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NwbDatePickerModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, NwbCommonModule],
                providers: [],
                entryComponents: [NwbDatePickerComponent],
                declarations: [
                    NwbDatePickerComponent,
                    NwbDatePickerInputStartDirective,
                    NwbDatePickerInputEndDirective,
                    NwbDatePickerInputDateTypeDirective,
                ],
                exports: [NwbDatePickerComponent, NwbDatePickerInputStartDirective, NwbDatePickerInputEndDirective, NwbDatePickerInputDateTypeDirective]
            }]
    }], null, null); })();

const EXPORTED_EXPORTS = [
    NwbCommonModule,
    NwbAlertModule,
    NwbAnimatedCardModule,
    NwbDialogModule,
    NwbDropdownModule,
    NwbModalSearchModule,
    NwbPaginatorModule,
    NwbProgressBarModule,
    NwbSnackbarModule,
    NwbSortModule,
    NwbSwitchModule,
    NwbTabsModule,
    NwbEditInPlaceModule,
    NwbDatePickerModule
];
class NwbAllModule {
}
NwbAllModule.ɵfac = function NwbAllModule_Factory(t) { return new (t || NwbAllModule)(); };
NwbAllModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: NwbAllModule });
NwbAllModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ providers: [], imports: [[], NwbCommonModule, NwbAlertModule, NwbAnimatedCardModule, NwbDialogModule, NwbDropdownModule, NwbModalSearchModule, NwbPaginatorModule, NwbProgressBarModule, NwbSnackbarModule, NwbSortModule, NwbSwitchModule, NwbTabsModule, NwbEditInPlaceModule, NwbDatePickerModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NwbAllModule, { exports: [NwbCommonModule, NwbAlertModule, NwbAnimatedCardModule, NwbDialogModule, NwbDropdownModule, NwbModalSearchModule, NwbPaginatorModule, NwbProgressBarModule, NwbSnackbarModule, NwbSortModule, NwbSwitchModule, NwbTabsModule, NwbEditInPlaceModule, NwbDatePickerModule] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NwbAllModule, [{
        type: NgModule,
        args: [{
                imports: [],
                providers: [],
                entryComponents: [],
                declarations: [],
                exports: EXPORTED_EXPORTS
            }]
    }], null, null); })();

/*
 * Public API Surface of ng-wizi-bulma
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AnimationCurves, AnimationDurations, NWB_DATE_LOCALE, NWB_DATE_LOCALE_FACTORY, NwbAlertComponent, NwbAlertModule, NwbAlertService, NwbAllModule, NwbAnimatedCardComponent, NwbAnimatedCardModule, NwbCommonModule, NwbDatePickerComponent, NwbDatePickerDefaultSettings, NwbDatePickerFormat, NwbDatePickerInputBaseDirective, NwbDatePickerInputDateTypeDirective, NwbDatePickerInputEndDirective, NwbDatePickerInputStartDirective, NwbDatePickerIntl, NwbDatePickerModule, NwbDebounceDirective, NwbDialogComponent, NwbDialogConfig, NwbDialogModule, NwbDialogService, NwbDropdownComponent, NwbDropdownModule, NwbEditInPlaceComponent, NwbEditInPlaceModule, NwbFilter, NwbFilterGroup, NwbFilterRoutingBuilder, NwbModalSearchComponent, NwbModalSearchConfig, NwbModalSearchModule, NwbModalSearchService, NwbOptionComponent, NwbPageEvent, NwbPaginatorComponent, NwbPaginatorIntl, NwbPaginatorModule, NwbProgressBarComponent, NwbProgressBarModule, NwbSnackbarComponent, NwbSnackbarModule, NwbSnackbarService, NwbSort, NwbSortHeaderComponent, NwbSortModule, NwbSpinnerComponent, NwbSwitchComponent, NwbSwitchModule, NwbTabComponent, NwbTabsComponent, NwbTabsModule, NwbToolTipDirective, SafeHtmlPipe, getSortDuplicateSortableIdError, getSortHeaderMissingIdError, getSortHeaderNotContainedWithinSortError, getSortInvalidDirectionError, nwbSortAnimations, OverlayContainer as ɵa, OVERLAY_CONTAINER_PROVIDER_FACTORY as ɵb, OVERLAY_CONTAINER_PROVIDER as ɵc, DomService as ɵd, DOM_SERVICE_PROVIDER_FACTORY as ɵe, DOM_SERVICE_PROVIDER as ɵf };

//# sourceMappingURL=wizishop-ng-wizi-bulma.js.map